import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ZoneCoordModel } from './shared/models/zone-model';
import { NatioCoordModel } from './shared/models/natio-model';
import { LocalCoordModel } from './shared/models/localcoord-model';
import { CountryModel } from './shared/models/country-model';
import { environment } from 'src/environments/environment';
import { ResponseQueryModel } from './shared/models/response-query-model';
import { TeamFunctionModel } from './shared/models/team-function-model';
import { EventOptionEnty } from './shared/models/EventOptionEntity';
import { Events } from './shared/models/Events';
import { EventparticipEntity } from './shared/models/EventparticipEntity';
import { TranslateDocument } from './shared/models/TranslateDocument';
import { TranslateRelLabelVO } from './shared/models/TranslateRelLabelVO';
import { UserAppVO } from './shared/models/UserAppVO';
import { CategoryLan } from './shared/models/CategoryLan';
import { ReqHSupplRespVO } from './shared/vo/ReqHSupplRespVO';
import { EmailsDocument } from './shared/models/EmailsDocument';
import { CountryVO } from './shared/models/CountryVO';
import { IncidentsDocument } from './shared/models/IncidentsDocument';
import { IncidentsDtl } from './shared/models/IncidentsDtl';
import { ResponseFile } from './shared/models/ResponseFile';
import { UsersSupportDoc } from './shared/models/UsersSupportDoc';
import { IncidentsAsigned } from './shared/models/IncidentsAsigned';
import { OptionsAssistDocument } from './shared/models/OptionsAssistDocument';
import { StorePeriod } from './shared/models/StorePeriod';
import { LstStorePeriodResponse } from './shared/models/lstStorePeriodResponse';
import { Store } from './shared/models/Store';
import { LstStoreResponse } from './shared/models/lstStoreResponse';
import { OptionsRulesDocument } from './shared/models/OptionsRulesDocument';
import { UsersSupportWrapperVO } from './shared/models/UsersSupportWrapperVO';
import { Participant } from './shared/models/Participant';
import { Form0ChurchAdress } from './shared/models/Form0ChurchAdress';

import { State } from './shared/models/State';
import { Address } from './shared/models/Address';
import { WsParticipantsWrpVO } from './shared/models/WsParticipantsWrpVO';
import { WrkSessAssist } from './shared/models/WrkSessAssist';
import { ParticipantServiceSession } from './shared/models/ParticipantServiceSession';
import { WSSessDate } from './shared/models/WSSessDate';
import { GuidesResponseVO } from './shared/models/GuidesResponseVO';
import { WrksResponseVO } from './shared/models/WrksResponseVO';
import { WrksParcipResVO } from './shared/models/WrksParcipResVO';
import { SecurityDocument } from './shared/models/SecurityDocument';
import { PeriodsVO } from './shared/models/PeriodsVO';
import { ExternGuidesDocument } from './shared/models/ExternGuidesDocument';
import { GuideModel } from './shared/models/guide-model';
import { TracingWokrshopsVO } from './shared/vo/TracingWokrshopsVO';
import { Workshops01VO } from './shared/vo/Workshops01VO';
import { ItemsCurrentPriceVO } from './shared/models/ItemsCurrentPriceVO';
import { BalanceVO } from './shared/models/BalanceVO';
import { PurchDowloadsVO } from './shared/models/PurchDowloadsVO';
import { FileCtl } from './shared/models/FileCtl';
import { ItemsTrack } from './shared/models/ItemsTrack';
import { Item } from './shared/models/Item';
import { ItemsAlbum } from './shared/models/ItemsAlbum';
import { AssistHdr } from './shared/models/AssistHdr';
import { AssistDt1 } from './shared/models/AssistDt1';
import { AssistDt2 } from './shared/models/AssistDt2';
import { User } from './_models';
import { GuideMatDtlVO } from './shared/models/GuideMatDtlVO';
import { MaterialBorrow } from './shared/models/MaterialBorrow';
import { Form0 } from './shared/models/Form0';
import { Wstype } from './shared/models/Wstype';
import { GenericMessageVO } from './shared/models/GenericMessageVO';
import { AuthorityOptsDocument } from './shared/models/AuthorityOptsDocument';
import { GuideReportVO } from './shared/models/GuideReportVO';
import { type } from 'os';
import { TreeNodeTovpil } from './shared/models/TreeNodeTovpil';
import { PurchasingSum } from './shared/models/PurchasingSum';
import { ChurchAdressVO } from './shared/models/ChurchAdressVO';
import { ValuesVO } from './shared/models/ValuesVO';
import { Form0WrpVO } from './shared/models/Form0WrpVO';
import { ResponseVO } from './shared/models/ResponseVO';
import { SchoolFpgVO } from './shared/models/SchoolFpgVO';
import { SchoolFpgDataVO } from './shared/models/SchoolFPGDataVO';
import { VersionHistory } from './shared/models/VersionHistory';
import { StructureNodeVO } from './shared/models/CordinationCatalog';
import { FiiConceptLang } from './shared/models/FiiConceptLang';
import { PriceListInt } from './shared/models/PriceList';
import { CountryPrice } from './shared/models/CountryPrice';
import { PriceListZone } from './shared/models/PriceListZone';
import { Category } from './shared/models/Category';
import { ListPrice } from './shared/models/ListPrice';
import { ExchangeRate } from './shared/models/ExchangeRate';
import { LocMatCtlH } from './shared/models/LocMatCtlH';
import { LocMatCtlMPK, LocMatCtlM } from './shared/models/LocMatCtlM';
import { LocMatCtlD } from './shared/models/LocMatCtlD';
import { FiiMonth } from './shared/models/FiiMonth';
import { LCSelector } from './shared/models/LCSelector';
import { FiiDtl } from './shared/models/FiiDtl';
import { Guide } from './shared/models/Guide';
import { UserPreferences } from './shared/models/UserPreferences';
import { FiiJournalConcept } from './shared/models/FiiJournalConcept';
import { FiiJournalSummary } from './shared/models/FiiJournalSummary';
import { CommentsF } from './shared/models/CommentsF';
import { JournalPerYear } from './shared/models/JournalPerYear';
import { FiiJournalDetailConcept } from './shared/models/FiiJournalDetailConcept';
import { FVSummaryWrp } from './shared/models/FVSummaryWrp';
import { FVDetailMater } from './shared/models/FVDetailMater';
import { RecPay } from './shared/models/RecPay';
import { StoreCurrency } from './shared/models/StoreCurrency';
import { MatNatReqStsHVO } from './shared/models/MatNatReqStsHVO';
import { MatNatItemQtyVO } from './shared/models/MatNatItemQtyVO';
import { ZoneCoordWrapper } from './shared/models/ZoneCoordWrapper';
import { PurchItmDwnAppVO } from './shared/models/PurchItmDwnAppVO';
import { PurchItmDwnAppHVO } from './shared/models/PurchItmDwnAppHVO';
import { PurchItmDwn } from './shared/models/PurchItmDwn';
import { AddressBook } from './shared/models/AddressBook';
import { NatioCoordWrapper } from './shared/models/NatioCoordWrapper';
import { LocalCoordWrapper } from './shared/models/LocalCoordWrapper';
import { IntItemSalesHdrVO } from './shared/models/IntItemSalesHdrVO';
import { StoreSupRelationVO } from './shared/models/StoreSupRelationVO';
import { OpenAssignedFolios } from './shared/models/OpenAssignedFolios';
import { PropertiesDocumentCrudWrapper } from './shared/models/PropertiesDocumentCrudWrapper';
import { ExternGuideDocumentCrudWrapper } from './shared/models/ExternGuideDocumentCrudWrapper';
import { CXC2HeaderWrapper } from './shared/vo/CXC2HeaderWrapper';
import { VideoCollectionWrapper } from './shared/models/VideoCollectionWrapper';
import { FiiconceptlangPK } from './shared/models/FiiconceptlangPK';
import { FiiConcept } from './shared/models/FiiConcept';
import { ValueCategory } from './shared/models/ValueCategory';
import { CXC2DetailWrapper } from './shared/vo/CXC2DetailWrapper';
import { LocMatCtlWrp } from './shared/vo/LocMatCtlWrp';
import { Fiijournaliedr } from './shared/models/Fiijournaliedr';
import { OfferDieWrapper } from './shared/vo/OfferDIEWrapper';
import { CXC4OfferWrapper } from './shared/vo/CXC4OfferWrapper';
import { FVIIEconRealWrp } from './shared/vo/FVIIEconRealWrp';
import { GuideMediaVO } from './shared/models/GuideMediaVO';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private SERVER_URL = environment.urlApi;

  private LOGIN = this.SERVER_URL + "commons/loginSecurity";

  private CREATE_ADDRESSBOOK = this.SERVER_URL + 'catalogs/createAddressBook';
  private GET_PROPERTY_VALUE = this.SERVER_URL + 'commons/getPropertyValue'
  private UPDATE_ADDRESSBOOK = this.SERVER_URL + 'catalogs/updateAddressBook';
  private GET_NATIOS_BY_ZONE = this.SERVER_URL + 'catalogs/getNatiosByZone';
  private GET_LOCALS_BY_ZONE = this.SERVER_URL + 'catalogs/getLocalsByNatio';
  private GET_NATIO_COORD_BY_ID = this.SERVER_URL + 'catalogs/getNatioCoordById';
  private CRUD_ZONE_COORD = this.SERVER_URL + 'catalogs/crudZoneCoord';
  private CRUD_NATIO_COORD = this.SERVER_URL + 'catalogs/crudNatioCoord';
  private CRUD_LOCAL_COORD = this.SERVER_URL + 'catalogs/crudLocalCoord';
  private GET_ZONES_COORD = this.SERVER_URL + "catalogs/getZonesCoord";
  private GET_ZONE_COORD_BY_ID = this.SERVER_URL + "catalogs/getZoneCoordById";
  private GET_NATIO_COORD = this.SERVER_URL + "catalogs/getAllNatioCoord";
  private GET_LOCAL_COORD = this.SERVER_URL + "catalogs/getAllLocalCoord";
  private GET_COUNTRIES = this.SERVER_URL + "catalogs/getCountries";
  private GET_COUNTRIES_FROMSTORE = this.SERVER_URL + "catalogs/getCoutriesFromStore";
  private GET_TEAM_ZONE = this.SERVER_URL + "catalogs/getTeamZonesCoord";
  private FIND_USER_BY_ANYID = this.SERVER_URL + "catalogs/findUserByAnyId";
  private LIST_OPTIONS_BY_EVENT_ID = this.SERVER_URL + "event/listOptionsByEventId";
  private EVENT_BY_SHORT_NAME = this.SERVER_URL + "event/getEventByShortName";
  private EVENT_PARTICIP = this.SERVER_URL + "event/getEventparticip";
  private TRANSLATE_BY_LANGUAGE_FIELD = this.SERVER_URL + "commons/getTranslateByLanguageField";
  private TRANSLATE_BY_LANGUAGE_MULTIPLE_FIELDS = this.SERVER_URL + "commons/listByLanguageMultFields";
  private USER_EVENT = this.SERVER_URL + "event/userEvent";
  private UPDATE_LST_VOTES = this.SERVER_URL + "event/updateLstVotes";
  private CATEGORY_LANG = this.SERVER_URL + "catalogs/getCategoryLang";
  private CATEGORY_BYID = this.SERVER_URL + "catalogs/getCategoryById";
  private CATEGORY_TRANSLATION = this.SERVER_URL + "catalogs/getCategoryTranslation";
  private CHECK_GRANT_AUDIO_PLAY = this.SERVER_URL + "materials/checkGrantAudioPlay";

  private PURCH_ITEM_UPADTE = this.SERVER_URL + 'materials/updatePurchItmDwn';
  private SUPPLIES_REQUESTED = this.SERVER_URL + "materials/supplRequested";
  private MATERIAL_REQUEST_ORDER_STATUS = this.SERVER_URL + "materials/lstMatrequesthOdersStatus";
  private MATERIAL_GET_REQ_ITEMS_QTY = this.SERVER_URL + "materials/getReqDItemsQty";
  private EMAILS_LISTTRANSLATEDCOUNTRYS = this.SERVER_URL + "catalogs/listTranslatedCountrys";
  private INCIDENTS_LIST_BY_STATUS_ZON_NAT = this.SERVER_URL + "commons/listIncidentsByStatusZonNatUsr";
  private INCIDENTS_LIST_OPEN = this.SERVER_URL + "commons/listOpenIncidents";
  private INCIDENTS_LISTCLOSEDINCIDENTS = this.SERVER_URL + "commons/listClosedIncidents";
  private INCIDENTS_LISTINCIDENTSDTLBYID = this.SERVER_URL + "commons/listIncidentsDtlById";
  private INCIDENTS_FINDBYINCIDENTID = this.SERVER_URL + "commons/findByIncidentId";
  private INCIDENTS_UPDATEINCIDENT = this.SERVER_URL + "commons/updateIncident";
  private FILES_GETFILESANTOAPP = this.SERVER_URL + "commons/getFileSantoApp";
  private FILES_GETFILEBINSANTOAPP = this.SERVER_URL + "commons/getFileBinSantoApp";
  private FILES_GETLISTFILESANTOAPP = this.SERVER_URL + "commons/getListFileSantoApp";
  private FILES_SAVEFILESANTOAPP = this.SERVER_URL + "commons/saveFileSantoApp";
  private INCIDENTS_INCIDENTS_ASSIGNEDTO = this.SERVER_URL + "commons/findIncidentsAssignedTo";
  private INCIDENTSDTL_CREATE = this.SERVER_URL + "commons/createIncidentsDtl";
  private INCIDENTSDTL_UPDATE = this.SERVER_URL + "commons/updateIncidentsDtl";
  private USERSSUPPORT_GETALL = this.SERVER_URL + "commons/getAllUsersSupport";
  private USERSSUPPORT_FINDBYUSERID = this.SERVER_URL + "commons/findUsersSupportByUserId";
  private OPTIONSASSIST_CREATE_UPDATE = this.SERVER_URL + "commons/createUpdateOptionsAssist";
  private OPTIONSASSIST_GET_BY_KEY = this.SERVER_URL + "commons/getOptionsAssistByKey";
  private GET_LIST_STORES = this.SERVER_URL + "catalogs/lstChildStores";
  private OPERATION_STORED_PERIOD = this.SERVER_URL + "catalogs/crtDelPeriodStoreId";
  private GET_STORE_BYID = this.SERVER_URL + "catalogs/getStoreById";
  private GET_OPTION_RULES_BY_OPTION = this.SERVER_URL + "commons/listOptionsRulesByOptionId";
  private CREATE_OPTION_RULES = this.SERVER_URL + "commons/createOptionsRules";
  private UPDATE_OPTION_RULES = this.SERVER_URL + "commons/updateOptionsRules";
  private DELETE_OPTION_RULES = this.SERVER_URL + "commons/deleteOptionsRules";
  private CREATE_USER_SUPPORT = this.SERVER_URL + "commons/createUsersSupport";
  private DELETE_USER_SUPPORT = this.SERVER_URL + "commons/deleteUsersSupport";
  private UPDATE_USER_SUPPORT = this.SERVER_URL + "commons/updateUsersSupport";
  private GET_PARTICIPANT_BY_SERVICES = this.SERVER_URL + "secretary/listParticipantsByService";
  private GET_DETAIL_FORM0 = this.SERVER_URL + "secretary/getFormDetailById";
  private FIND_WORKSHOPSDETAI_BYID = this.SERVER_URL + "secretary/findWorkShopsDetailByID";
  private CREATE_PARTICIPANT_FORM0 = this.SERVER_URL + "secretary/createWSParticipantWrp";
  private DELETE_PARTICIPANT_FORM0 = this.SERVER_URL + "secretary/deleteWSParticipants";
  private GET_STATE_BY_COUNTRY = this.SERVER_URL + "catalogs/getStatesByCountry";
  private GET_ADDRESS_BY_ID = this.SERVER_URL + "catalogs/getAddressBookById";
  private GET_SESSIONS_FORM0 = this.SERVER_URL + "secretary/listSessByService";
  private GET_PART_BY_SERVICE_SESS = this.SERVER_URL + "secretary/listPartByServiceSession";
  private REGISTER_ASSIST_PARTICIPANT = this.SERVER_URL + "secretary/createWsAttendance";
  private LIST_HST_GUIDES = this.SERVER_URL + "catalogs/listHstGuides";
  private LIST_WRKS_BY_GUIDETYPE = this.SERVER_URL + "secretary/lstWrksbyGuideType";
  private LIST_GUIDES_PART_INSERVICE = this.SERVER_URL + "secretary/listGuidesPartiInService";
  private REGISTER_DATE_ASSIST = this.SERVER_URL + "secretary/createWsSessDates";
  private FORM0_FINDBY_PERIOD_GUIDE = this.SERVER_URL + "secretary/findBy_Period_Guide";
  private GET_MATERIALS_BORROWBY_GUIDE = this.SERVER_URL + "secretary/getMaterialsBorrowByGuide";
  private GET_ITEMS_TO_APPROVE_FROM_ORDER = this.SERVER_URL + "materials/getItemsToApproveFromOrder";

  private GET_VALID_PERIODS = this.SERVER_URL + "commons/getValidPeriods";
  private GET_VALID_YEARS = this.SERVER_URL + "commons/getValidYears";
  private GET_DEPENDENT_OCAL_STORES = this.SERVER_URL + "catalogs/getDependetLocalStores";

  private GET_GUIDES_BY_ZONE_STS = this.SERVER_URL + "catalogs/getTotalGuidesByZone";
  private CREATE__LIST_EXTERN_GUIDES = this.SERVER_URL + "commons/createListExternGuides";
  private SEND_MESSAGES = this.SERVER_URL + "commons/sendMessages";
  private CHECK_TRANSACION_ACCESS = this.SERVER_URL + "commons/checkTransactionAccess";
  private GET_GUIDE_BY_ID = this.SERVER_URL + "catalogs/getGuideById";
  private UPDATE_GUIDE = this.SERVER_URL + "catalogs/updateGuide";
  private GET_TRACING_WORKSHOP = this.SERVER_URL + "secretary/tracingWokrshops";
  private GET_LIST_TRACING_WORKSHOP = this.SERVER_URL + "secretary/listWorkShops01";
  private GET_CURRENT_INT_ITEM_PRICE = this.SERVER_URL + "materials/getCurrentIntItemsPrc";
  private GET_CURRENT_ITEM_PRICE = this.SERVER_URL + "materials/getCurrentItemsPrc";
  private GET_GUIDE_MATERIAL_BYPERIOD = this.SERVER_URL + "materials/getGuideMatPeriod";
  private GET_GUIDE_BALANCE = this.SERVER_URL + "treasurer/getGuideBalance";
  private GET_BALANCE_BY_CONCEPT_DATES = this.SERVER_URL + "treasurer/getBalanceByConceptDates";
  private GET_PURCH_ITM_TO_DOWNLOAD = this.SERVER_URL + "materials/getPurchItemsToDownload";
  private UPDATE_FILECTL = this.SERVER_URL + "materials/updateFileCtl";
  private CREATE_FILECTL = this.SERVER_URL + "materials/createFileCtl";
  private LIST_ITEMSTRACK_BYITEMALBUM = this.SERVER_URL + "catalogs/listItemsTrackByItemAlbum";
  private LIST_ITEMSTRACK_BYITEMALBUMLANG = this.SERVER_URL + "catalogs/listItemsTrackByItemLanguage";
  private FIND_ALL_BY_LANGUAGE = this.SERVER_URL + "materials/findAllByLanguage";



  private CREATE_ITEMSTRACK = this.SERVER_URL + "catalogs/createItemsTrack";
  private UPDATE_ITEMSTRACK = this.SERVER_URL + "catalogs/updateItemsTrack";
  private GET_ITEMSTRACK_BYID = this.SERVER_URL + "catalogs/getItemsTrackById";
  private GET_ITEM_BYID = this.SERVER_URL + "catalogs/getItemById";
  private GET_ITEM_BYID_LANG = this.SERVER_URL + "catalogs/getItemByIdLang";
  private DELETE_ITEMSTRACK = this.SERVER_URL + "catalogs/deleteItemsTrack";
  private LIST_ITMALB_BYITMLANG = this.SERVER_URL + "catalogs/lstItmsAlbByItemLanguage";
  private GET_ITEMSALBUM_BYID = this.SERVER_URL + "catalogs/getItemsAlbumById";
  private CREATE_ITEMSALBUM = this.SERVER_URL + "catalogs/createItemsAlbum";
  private UPDATE_ITEMSALBUM = this.SERVER_URL + "catalogs/updateItemsAlbum";
  private DELETE_ITEMSALBUM = this.SERVER_URL + "catalogs/deleteItemsAlbum";
  private GET_ASSISTHDR_BYLANGUAGE = this.SERVER_URL + "catalogs/getAssistHdrByLanguage";
  private GET_ASSISTDT1_BYASSISTID = this.SERVER_URL + "catalogs/getAssistDt1ByAssistId";
  private GET_ASSISTDT2_BYASSISTID_SEQDT1 = this.SERVER_URL + "catalogs/getAssistDt2ByAssistIdDt1";
  private GET_ASSISTDT2_BYID = this.SERVER_URL + "catalogs/getAssistDt2ById";
  private CREATE_ASSISTDT2 = this.SERVER_URL + "catalogs/createAssistDt2";
  private UPDATE_ASSISTDT2 = this.SERVER_URL + "catalogs/updateAssistDt2";
  private DELETE_ASSISTDT2 = this.SERVER_URL + "catalogs/deleteAssistDt2";
  private GET_ASSISTHDR_BYID = this.SERVER_URL + "catalogs/getAssistHdrById";
  private GET_ASSISTDT1_BYID = this.SERVER_URL + "catalogs/getAssistDt1ById";
  private GET_WSTYPE_BYID = this.SERVER_URL + "catalogs/getWstypeById";
  private LIST_TRANSLATED_SERVICES = this.SERVER_URL + "catalogs/listTranslatedServices";
  private GET_ALL_AUTHORITYOPTS = this.SERVER_URL + "commons/getAllAuthorityOpts";
  private CREATE_AUTHORITYOPTS = this.SERVER_URL + "commons/createAuthorityOpts";
  private UPDATE_AUTHORITYOPTS = this.SERVER_URL + "commons/updateAuthorityOpts";
  private GET_GUIDES_REPORT = this.SERVER_URL + "catalogs/getGuidesReport";
  private GET_TOVPIL_STRUCTURE_TEAM = this.SERVER_URL + "catalogs/getStructureTovpilTeam";
  private FIND_ZONE_PRODUCTION_ORDERS = this.SERVER_URL + "materials/findZoneProductionOrders";

  private GET_WORKSHOPS_GUIDE = this.SERVER_URL + "secretary/getFormsByGuide";

  private FIND_WORKSHOPS_BYGUIDEID = this.SERVER_URL + "secretary/findWorkShopsByGuideId";
  private GET_CHURCH_BY_COUNTRY_STATE = this.SERVER_URL + "catalogs/getChurchByCountryState";
  private GET_CHURCH_ADDRESS_BYID = this.SERVER_URL + "catalogs/getChurchAdressById";
  private GET_GUIDES_BY_STORE = this.SERVER_URL + "catalogs/listGuidesByStore";
  private LIST_PARTNER_GUIDES = this.SERVER_URL + "catalogs/listPartnerGuides";
  private GET_WORKSHOPS_TYPE_BY_GUIDE = this.SERVER_URL + "catalogs/listWstypeByGuideType";
  private CREATE_WORKSHOP_GUIDE = this.SERVER_URL + "secretary/createForm0";
  private CREATEUPDATECANCEL_FORM0WRP = this.SERVER_URL + "secretary/createUpdateCancelForm0Wrp";
  private UPDATE_WORKSHOP_GUIDE = this.SERVER_URL + "secretary/updateForm0";
  private DELETE_WORKSHOP_GUIDE = this.SERVER_URL + "secretary/deleteForm0";
  private GET_LIST_ASSITANCE_WRK = this.SERVER_URL + "secretary/listPartByServiceAllSession";
  private LIST_FG_SERVICE_ALL_SESSIONS = this.SERVER_URL + "secretary/ListFGByServiceAllSession";
  private CREATE_UPDATE_ASSITANCE_WORKSHOP = this.SERVER_URL + "secretary/createUpdateListAttend";
  private CREATE_UPDATE_LIST_GF_ATTENDANCE = this.SERVER_URL + "secretary/createUpdateListFGAttendande";

  private UPDATE_PASSWORD = this.SERVER_URL + "catalogs/updatePassword";
  private PASSWORD_RECOVER = this.SERVER_URL + "catalogs/passwordRecover";
  private VALIDATE_ACCESS_GETGUIDEID = this.SERVER_URL + "catalogs/validateAccess_getGuideId";
  private CREATE_USER = this.SERVER_URL + "catalogs/createUserMobile";
  private GET_GUIDE_PROFILE = this.SERVER_URL + "catalogs/getGuideProfile";
  private GET_CITIES_FROM_STATE = this.SERVER_URL + "catalogs/getCitysFromCountryState";
  private get_List_Spk_Lang_ByStoreId = this.SERVER_URL + "catalogs/getListSpkLangByStoreId";
  private GET_STATUS_TRANSITION_RULES = this.SERVER_URL + "catalogs/getStatusTransitionRules";
  private GET_LIST_CHURCHES_FILTER = this.SERVER_URL + "catalogs/findChurchsByCountryState";
  private GET_LIST_CHURCHES__STATEUSER_FILTER = this.SERVER_URL + "catalogs/findChurchsByCountryStateUser";
  private CRUD_CHURCH = this.SERVER_URL + "catalogs/getCreateUpdateCancelChurch";
  private FIND_PURCHITMDWN_BYSTORE = this.SERVER_URL + "materials/findPurchItmDwnByStore";
  private CRUD_PURCHITMDWN = this.SERVER_URL + "materials/getCreateUpdatePurchItmDwn";
  private GET_PURCHITMDWN_BYID = this.SERVER_URL + "materials/getPurchItmDwnById";
  private LIST_TRANSLATED_ITEMS = this.SERVER_URL + "catalogs/listTranslatedItems";
  private FIND_PURCHITMDWN_BYPASSKEY = this.SERVER_URL + "materials/findPurchItmDwnByPassKey";
  private DELETE_PURCHITMDWN = this.SERVER_URL + "materials/deletePurchItmDwn";
  private FIND_PURCHITMDWN_BYGUIDEID = this.SERVER_URL + "materials/findPurchItmDwnByGuideId";
  private FIND_PURCHITMDWN_BYGUIDEID_AVAILABLE = this.SERVER_URL + "materials/findPurchItmDwnByGuideIdAvailable";

  private GET_GUIDE_ITEMS_TO_PLAY = this.SERVER_URL + "materials/getGuideItemsToPlay";
  private GET_ALL_SCHOOLFPG = this.SERVER_URL + "catalogs/listSchoolFPGFullData";
  private UPDATE_SCHOOLFPG = this.SERVER_URL + "catalogs/updateSchoolFPG";
  private CHANGE_SCHOOL_STATUS = this.SERVER_URL + "catalogs/changeSchoolStatus";
  private GET_ALL_SCHOOLFPG_CRUD = this.SERVER_URL + "catalogs/getCreateUpdateCancelSchoolFP";

  private LIST_DEPENDENT_LOCAL_STORES = this.SERVER_URL + "catalogs/listDependetLocalStores";
  private GET_PARTICIPANT_SCHOOLFPG_BY_SERVICES = this.SERVER_URL + "secretary/listSchoolEnrollFGGuideAndAddress";
  private GET_CREATE_UPDATE_CANCE_SCHOOLENROOLFG = this.SERVER_URL + "secretary/getCreateUpdateCancelSchoolEnrollFG";
  private FIND_OPEN_SCHOOL_BY_GUIDE = this.SERVER_URL + "catalogs/findOpenSchoolsByGuideId";

  private CHANGE_STATUS_GUIDE = this.SERVER_URL + "catalogs/changeStatusGuide";
  private SCHOOLFPG_PARTICIPANT_SEND_GUIDE = this.SERVER_URL + "catalogs/sendGuide";
  private LIST_STATUS_GUIDE = this.SERVER_URL + "catalogs/listStatusGuide";
  private LIST_WORKSHOP_BY_STORE_ID = this.SERVER_URL + "secretary/listWorkShopsByStoreId";
  private CHANGE_WRKS_STATUS = this.SERVER_URL + "secretary/changeWrksStatus";

  private CREATE_VERSION_HISTORY_URL = this.SERVER_URL + "commons/createVersionHistory";
  private GET_ALL_VERSION_HISTORY_URL = this.SERVER_URL + "commons/getAllVersionHistory";
  private DELETE_VERSION_HISTORY_URL = this.SERVER_URL + "commons/deleteVersionHistory";
  private UPDATE_VERSION_HISTORY_URL = this.SERVER_URL + "commons/updateVersionHistory";

  private GET_FG_HISTORIAL_CHANGES = this.SERVER_URL + "secretary/ListCommentsFByKey";
  private FIND_PO_BY_STOREID = this.SERVER_URL + "materials/findPurchordhByStoreId";
  private FIND_PO_BY_SUPPL_STOREID = this.SERVER_URL + "materials/findPurchordhBysupplStoreId";
  private LIST_SUPPLIERS_BY_SUPSTOREID = this.SERVER_URL + "catalogs/lstSuppliersBySupStoreId";
  private LIST_CORDINATION_CATALOGS = this.SERVER_URL + "catalogs/getStructureData";
  private LIST_GETDYN_QUERY = this.SERVER_URL + "catalogs/getDynQuery";
  private GET_CATEGORY = this.SERVER_URL + "catalogs/getCategory";
  private FIND_MAX_EXCHANGE_RATE = this.SERVER_URL + "treasurer/findMaxExchangeRate";

  private CREATE_PRICE_LIST_INT = this.SERVER_URL + "materials/createPriceListInt";
  private UPDATE_PRICE_LIST_INT = this.SERVER_URL + "materials/updatePriceListInt";
  private GET_PRICE_LIST_INT_BY_ID = this.SERVER_URL + "materials/getPriceListIntById";

  private UPDATE_PRICE_LIST_INT_H = this.SERVER_URL + "materials/updatePriceListInth";

  private GET_PRICE_LIST_INT_H_BY_ID = this.SERVER_URL + "materials/getPriceListInthById";
  private CREATE_PRICE_LIST_INT_H = this.SERVER_URL + "materials/createPriceListInth";

  private UPDATE_CATEGORY_BY_ID = this.SERVER_URL + "catalogs/updateCategory";
  private CLONE_PRICE_LIST_INT_BY_ID = this.SERVER_URL + "materials/clonePriceListIntByID";

  private FIND_BY_COUNTRY_CURR_LANG = this.SERVER_URL + "materials/findByCountryCurrLang";
  private MARK_AS_SELECTED_PRICE_LISTZ = this.SERVER_URL + "materials/markAsSelected";
  private UPDATE_PRICE_LISTZ = this.SERVER_URL + "materials/updatePricelisth";

  private GET_PRICE_LIST_BY_ID = this.SERVER_URL + "materials/getPricelistById";
  private CREATE_PRICE_LIST_ZONE = this.SERVER_URL + "materials/createPricelist";
  private UPDATE_PRICE_LIST_ZONE = this.SERVER_URL + "materials/updatePricelist";
  private UPDATE_PRICE_LIST_ITM = this.SERVER_URL + "materials/updatePriceListItm";

  private GET_STORE_MATERIALS_BY_COUNTRY = this.SERVER_URL + "catalogs/getStoreMaterialsByCountry";
  private GET_COUNTRY_MATERIALS = this.SERVER_URL + "catalogs/getCountryMaterials";
  private LIST_ITEMS_STORE_COUNTRY = this.SERVER_URL + "catalogs/listItemsStoreCountry";
  private CREATE_UPDATE_PRICE_LIST_ZONE = this.SERVER_URL + "materials/createUpdatePriceListDetail";

  private FIND_PROPERTIES_BY_KEY = this.SERVER_URL + "commons/findPropertiesByKey";
  private DWD_CURRENT_PRICE_ZONE = this.SERVER_URL + "materials/dwdCurrentPriceZone";


  private GET_GUIDES_BY_YEAR_PERIOD = this.SERVER_URL + "catalogs/getGuidesByYearAndPeriod";
  private GET_LOAD_SERVS = this.SERVER_URL + "catalogs/getLoadServs";
  private GET_LOAD_AMOUNT = this.SERVER_URL + "materials/getLoadAmount";
  private GET_LOAD_SALES_CONS = this.SERVER_URL + "materials/getSalesCons";
  private GET_SAVE_PEND_AMOUNT = this.SERVER_URL + "secretary/savePendAmount";

  private GET_MATERIAL_REQUEST = this.SERVER_URL + "materials/getMaterialRequest";
  private UPDATE_MATERIAL_REQUEST = this.SERVER_URL + "materials/updateMaterialRequest";
  private DELETE_MATERIAL_REQUEST = this.SERVER_URL + "materials/deleteMaterialRequest";

  private GET_GUIDE_REQ_MAT = this.SERVER_URL + "materials/getGuideReqMat";

  private GET_SELECTED_PRICE_LIST = this.SERVER_URL + "materials/getSelectedPriceList";
  private FIND_BY_PERIOD_GUIDE_DESCRIP = this.SERVER_URL + "secretary/findByPeriodGuideDescrip";
  private BUSCA_CATEGORY = this.SERVER_URL + "catalogs/utils/buscaCateg";
  private GET_PUBLIC_PACK_LIST_PRICE = this.SERVER_URL + "materials/getPublicPackListPrice";


  private GET_LOCMATCTL_H = this.SERVER_URL + "materials/getUpdateLocmatctlh";
  //private UPDATE_CREATE_LOCMATCTL_H = this.SERVER_URL + "materials/createUpdateLocmatctlh";
  private GET_LOCMATCTL_M = this.SERVER_URL + "materials/getUpdateLocmatctlm";
  private UPDATE_CREATE_LOCMATCTL_M = this.SERVER_URL + "materials/createUpdateLocmatctlm";
  private GET_LOCMATCTL_D = this.SERVER_URL + "materials/getUpdateLocmatctld";
  private UPDATE_CREATE_LOCMATCTL_D = this.SERVER_URL + "materials/createUpdateLocmatctld";
  private REMOVE_RECORD_LOCMATCTL_M = this.SERVER_URL + "materials/removeRecord";

  private GET_LIST_ORDER_GUIDES_BY_ID = this.SERVER_URL + "materials/listOrderGuidesByPeriod";
  private APPROVE_LOCMATCTL_INVENTORY = this.SERVER_URL + "materials/approveInventory";
  // EMAILS
  private GET_EMAIL_BY_EMAIL = this.SERVER_URL + "catalogs/getEmailsCtlById"
  private EMAILS_LISTEMAILSBYSTATUS = this.SERVER_URL + "catalogs/listEmailsCtlByStatus";
  private EMAILS_UPDATEEMAILLIST = this.SERVER_URL + "catalogs/updateEmailsCtlList";
  private EMAILS_UPDATE = this.SERVER_URL + "catalogs/updateEmailsCtl";
  private LIST_BY_EMAILS = this.SERVER_URL + "catalogs/listByEmails";


  // CX4
  private LST_TREE_CHILD_STORES = this.SERVER_URL + "catalogs/lstTreeChildStores";
  private GET_STORE_WITH_DESCRIP = this.SERVER_URL + "catalogs/getStoreByIdDescrip";
  private GET_FII_MONTHS = this.SERVER_URL + "treasurer/listFIIMonths";
  private GET_CHECK_OPEN_ORDERS = this.SERVER_URL + "materials/checkOpenOrders";

  private GET_GUIDE_STORE_NAME_LASTNAME = this.SERVER_URL + "catalogs/findByStoreNameAndLastName";
  private GET_CREATE_UPDATE_DELETE_FII_DTL = this.SERVER_URL + "treasurer/getCreateUpdateDeleteFIIDtl";

  private SAVE_UPDATE_USER_PREFERENCES = this.SERVER_URL + "catalogs/saveUserPreferences";
  private GET_USER_PREFERENCES = this.SERVER_URL + "catalogs/getUserPreferencesByStoreId";

  private CRUD_INCIDENTS = this.SERVER_URL + "commons/getCreateUpdateDeleteIncident";
  private GET_LIST_FII_JOURNAL_WITH_CONCEPT = this.SERVER_URL + "treasurer/listFIIJournalDetailWithConcepts";
  private GET_USER_BY_ID = this.SERVER_URL + "catalogs/getUserById";
  private GET_LIST_FII_JOURNAL_SEMESTER_WITH_CONCEPT = this.SERVER_URL + "treasurer/listFIIJournalSemesterWithConcepts";
  private GET_LIST_FII_JOURNAL_SUMMARY = this.SERVER_URL + "treasurer/listFIIJournalSummary";

  private GET_LIST_JRN_GUIDE_REFERINC = this.SERVER_URL + "treasurer/listJrnHGuideReferIncExp";
  private GET_JRN_GUIDE_REFERINC_EXP = this.SERVER_URL + "treasurer/findJrndByGuideReferIncExpId";
  private CRUD_JRNH_OFFER = this.SERVER_URL + "treasurer/createUpdateDeleteJrnHOffer";

  private GET_LIST_SUMMARY_MATTER = this.SERVER_URL + "treasurer/listFVSummaryMater";



  private RETRIEVE_COMMENTS_BY_DATE = this.SERVER_URL + "secretary/retrieveCommentsByDate";
  private CREATE_COMMENTS_F = this.SERVER_URL + "secretary/createCommentsf";
  private LIST_STATIS_FOR_FI = this.SERVER_URL + "secretary/listStatistForFI";

  // USER PREFERENCES 
  private FIND_SECURITY_BY_ID = this.SERVER_URL + "commons/findSecurityById";
  private UPDATE_SECURITY_BY_ID = this.SERVER_URL + "commons/updateSecurity";

  private GET_COMMENTSF_BY_ID = this.SERVER_URL + "secretary/getCommentsfById";
  private UPDATE_COMMENTSF_BY_ID = this.SERVER_URL + "secretary/updateCommentsf";
  private APPROVE_SEND_JOURNAL = this.SERVER_URL + "treasurer/approveSendJournalPer";

  private GET_APPROVE_REJECT_JOURNL_PER = this.SERVER_URL + "treasurer/getApproveRejectJournalPer";
  private FIND_FII_JOURNAL_PER_BY_YEAR = this.SERVER_URL + "treasurer/findFiiJournalPerbyYear";
  private GET_LIST_FII_JOURNAL_DETAIL_BY_CONCEPT = this.SERVER_URL + "treasurer/listFIIJournalDetailByConceptId";

  private GET_LIST_STORES_TO_PAY = this.SERVER_URL + "catalogs/listStoresToPay";
  private CREATE_UPDATE_LIST_ATTEND_BY_SESSION = this.SERVER_URL + 'secretary/createUpdateListAttendBySession'
  private LST_FV_DETAIL_MATER = this.SERVER_URL + 'treasurer/listFVDetailMater'

  private GET_BY_REC_PAY = this.SERVER_URL + "treasurer/getRecpayById";
  private DELETE_REC_PAY = this.SERVER_URL + "treasurer/deleteRecpay";
  private CREATE_REC_PAY = this.SERVER_URL + "treasurer/createRecpay";
  private UPDATE_REC_PAY = this.SERVER_URL + "treasurer/updateRecpay";

  private DWD_WORKSHOPS_EXCEL = this.SERVER_URL + "secretary/dwdWorkshopsXls";
  private DWD_SFPG_EXCEL = this.SERVER_URL + "secretary/dwdSFPGSummaryExcel";

  private GET_LIST_DETAIL_GUIDES_MAT = this.SERVER_URL + "materials/listDetailGuidesMat";
  private GET_ALL_STORE_CURRENCY = this.SERVER_URL + "catalogs/getAllStoreCurrency";

  private CREATE_STORE_CURRENCY = this.SERVER_URL + "catalogs/createStoreCurrency";
  private UPDATE_STORE_CURRENCY = this.SERVER_URL + "catalogs/updateStoreCurrency";
  private DELETE_STORE_CURRENCY = this.SERVER_URL + "catalogs/deleteStoreCurrency";
  private GET_ONLY_COUNTRY_FROM_STORE = this.SERVER_URL + "catalogs/getOnlyCoutryFromStore";
  private DOWNLOAD_VIDEO = this.SERVER_URL + 'commons/getFileBinSantoApp';
  private GET_VIDEO_FROM_API = this.SERVER_URL + "commons/videoCollectionOptions";
  private GET_INTERNAT_ITEMS_SALES_BY_CATEGORY = this.SERVER_URL + "materials/internatItemsSalesByCategory";
  private GET_FIND_SUP_RELATION_BY_NAME = this.SERVER_URL + "catalogs/findSupRelationByName";
  private GET_FIND_SUP_RELATION_BY_STORE_ID = this.SERVER_URL + "catalogs/findSupRelationByStoreId";


  private OPEN_ASSIGNED_FOLIOS = this.SERVER_URL + "secretary/openAssignedFolios";
  private CRUD_PROPERTIES = this.SERVER_URL + "commons/crudPropertiesDocument";
  private LIST_TRANSLATED_ITEMS_BY_ITEMCAT3 = this.SERVER_URL + "catalogs/listTranslatedItemsbyItemCat3";
  private CRUD_EXTERN_GUIDE = this.SERVER_URL + "commons/crudExternGuidesDocument";

  private GET_LIST_VIDEOS_FROM_VIDEO_API = this.SERVER_URL + "commons/getListVideosFromVimeoApi";
  private CRUD_VIDEO_SERVICE = this.SERVER_URL + "catalogs/crudVideoService";

  //CRUD FII CONCEPTS
  private GET_FII_CONCEPTS_TRANSLATED = this.SERVER_URL + "treasurer/getFiiconceptByIdTrans";

  //CXC2
  private GET_FV_SUMMARY = this.SERVER_URL + "treasurer/getFVSummary";
  private GET_FV_DETAIL = this.SERVER_URL + "treasurer/getFVDetail";
  private FIND_SELECTED_CATEGORY = this.SERVER_URL + "catalogs/findSelectedCategory";
  private CREATE_DOUBLE_PARTY_DETAIL = this.SERVER_URL + "treasurer/createDoublePartyDetail";
  private UPDATE_DOUBLE_PARTY_DETAIL = this.SERVER_URL + "treasurer/updateDoublePartyDetail";

  //CXC3
  private GET_LOCMATCTL_M_BY_ID = this.SERVER_URL + "materials/getLocmatctlmById";
  private CRUD_LOCMATCTL = this.SERVER_URL + "materials/crudLocMatCtl";
  private UPDATE_LOCMATCTLM = this.SERVER_URL + "materials/updateLocmatctlm";
  private CREATE_LOCMATCTLM = this.SERVER_URL + "materials/createLocmatctlm"

  //ACCBALANCE
  private CREATE_ACCBALANCEH = this.SERVER_URL + "treasurer/createAccBalanceH";
  private UPDATE_ACCBALANCEH = this.SERVER_URL + "treasurer/updateAccBalanceH";
  private CREATE_ACCBALANCECD = this.SERVER_URL + "treasurer/createAccBalanceCD";
  private UPDATE_ACCBALANCECD = this.SERVER_URL + "treasurer/updateAccBalanceCD";
  private GET_ACCBALANCECD_BY_ID = this.SERVER_URL + "treasurer/getAccBalanceCDById";
  private GET_ACCBALANCEH_BY_ID = this.SERVER_URL + "treasurer/getAccBalanceHById";
  private DELETE_FV = this.SERVER_URL + "treasurer/deleteFV";
  private CREATE_BALANCE_BY_DOC = this.SERVER_URL + "treasurer/createBalanceByDocument";

  //Auth Options
  private GET_AUT_OPTS_BY_ID = this.SERVER_URL + "commons/getAuthorityOptsById";

  // CXC5
  private QUERY_FOR_CHARTS_WORKED_BY_GUIDE = this.SERVER_URL + "secretary/queryForChartsWorkedByGuide";
  private CREATE_FIIJOURNALIEDR_BY_LIST = this.SERVER_URL + "treasurer/createListFiijournaliedr";
  private LIST_FII_JOURNALIEDR_BY_DOC_ID = this.SERVER_URL + "treasurer/listFiijournaliedrByDocId";
  private UPDATE_FII_JOURNALIEDR_ARRAY = this.SERVER_URL + "treasurer/updateFiijournaliedrByArray";

  //FVII
  private LST_FVII_ECONREAL = this.SERVER_URL + "treasurer/lstFVIIEconReal";
  private LST_FVII_ECONREAL_XLS = this.SERVER_URL + "treasurer/dwnFVIIEconRealXls";


  private VALIDATE_EXTERN_GUIDES_AND_MEDIA = this.SERVER_URL + "commons/validateExternGuidesAndMedia";
  

  constructor(private httpClient: HttpClient) {

  }

  getLogin() {
    return this.LOGIN;
  }

  getZonesCoord() {
    return this.httpClient.get<any>(this.GET_ZONES_COORD)
      .toPromise()
      .then(res => res as ZoneCoordModel[])
      .then(data => data);
  }

  getNatioCoord(zoneId?: string) {
    let params = new HttpParams();
    if (zoneId) {
      params = params.append("zoneId", zoneId);
    }

    return this.httpClient.get<any>(this.GET_NATIO_COORD, { params: params })
      .toPromise()
      .then(res => res as NatioCoordModel[])
      .then(data => data);
  }

  getLocalCoord() {
    return this.httpClient.get<any>(this.GET_LOCAL_COORD)
      .toPromise()
      .then(res => res as LocalCoordModel[])
      .then(data => data);
  }

  getCountries() {
    return this.httpClient.get<any>(this.GET_COUNTRIES)
      .toPromise()
      .then(res => res as CountryModel[])
      .then(data => data);
  }

  getQueryApiGet(path: String) {
    const headers = new HttpHeaders({ 'Access-Control-Allow-Origin': '*', "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept" });

    return this.httpClient.get<any>(this.SERVER_URL + path, {
      headers: headers
    })
      .toPromise()
      .then(res => res as ResponseQueryModel)
      .then(data => data);
  }

  getTeamCoordZone(zoneId?: string) {
    let params = new HttpParams();
    if (zoneId) {
      params = params.append("zoneId", zoneId);
    }

    return this.httpClient.get<any>(this.GET_TEAM_ZONE, { params: params })
      .toPromise()
      .then(res => res as TeamFunctionModel[])
      .then(data => data);
  }

  getlistOptionsByEventId(body: any) {
    return this.httpClient.post<any>(this.LIST_OPTIONS_BY_EVENT_ID, body)
      .toPromise()
      .then(res => res as EventOptionEnty[])
      .then(data => data);
  }
  getEventByShortName(body: any) {
    return this.httpClient.post<any>(this.EVENT_BY_SHORT_NAME, body)
      .toPromise()
      .then(res => res as Events)
      .then(data => data);
  }
  getEventparticip(body: any) {
    return this.httpClient.post<any>(this.EVENT_PARTICIP, body)
      .toPromise()
      .then(res => res as EventparticipEntity)
      .then(data => data);
  }
  getTranslateByLanguageField(body: any) {
    return this.httpClient.post<any>(this.TRANSLATE_BY_LANGUAGE_FIELD, body)
      .toPromise()
      .then(res => res as TranslateDocument)
      .then(data => data);
  }
  listByLanguageMultFields(body: any) {
    return this.httpClient.post<any>(this.TRANSLATE_BY_LANGUAGE_MULTIPLE_FIELDS, body)
      .toPromise()
      .then(res => res as TranslateRelLabelVO[])
      .then(data => data);
  }
  getUserEvent(body: any) {
    return this.httpClient.post<any>(this.USER_EVENT, body)
      .toPromise()
      .then(res => res as UserAppVO)
      .then(data => data);
  }

  updateLstVotes(body: any) {
    return this.httpClient.post<any>(this.UPDATE_LST_VOTES, body)
      .toPromise()
      .then(res => res as UserAppVO)
      .then(data => data);
  }
  getCategoryLang(body: any) {
    return this.httpClient.post<any>(this.CATEGORY_LANG, body)
      .toPromise()
      .then(res => res as CategoryLan[])
      .then(data => data);
  }
  getCategoryById(body: any) {
    return this.httpClient.post<any>(this.CATEGORY_BYID, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getSuppliesRequested(body: any) {
    return this.httpClient.post<any>(this.SUPPLIES_REQUESTED, body)
      .toPromise()
      .then(res => res as ReqHSupplRespVO[])
      .then(data => data);
  }
  listEmailsByStatus(body: any) {
    return this.httpClient.post<any>(this.EMAILS_LISTEMAILSBYSTATUS, body)
      .toPromise()
      .then(res => res as EmailsDocument[])
      .then(data => data);
  }
  listTranslatedCountrys(language?: string) {
    let params = new HttpParams();
    if (language) {
      params = params.append("language", language);
    }
    return this.httpClient.get<any>(this.EMAILS_LISTTRANSLATEDCOUNTRYS, { params: params })
      .toPromise()
      .then(res => res as CountryVO[])
      .then(data => data);
  }
  updateEmailList(body: any) {
    return this.httpClient.post<any>(this.EMAILS_UPDATEEMAILLIST, body)
      //return this.httpClient.put<any>('/api/commons/updateEmail',body)
      .toPromise()
      .then(res => res as String)
      .then(data => data);
  }
  listAllIncidentsByStatusZonNat(body: any) {
    return this.httpClient.post<any>(this.INCIDENTS_LIST_BY_STATUS_ZON_NAT, body)
      .toPromise()
      .then(res => res as IncidentsDocument[])
      .then(data => data);
  }
  listOpenIncidents(body: any) {
    return this.httpClient.post<any>(this.INCIDENTS_LIST_OPEN, body)
      .toPromise()
      .then(res => res as IncidentsDocument[])
      .then(data => data);
  }
  listClosedIncidents() {
    return this.httpClient.get<any>(this.INCIDENTS_LISTCLOSEDINCIDENTS)
      .toPromise()
      .then(res => res as IncidentsDocument[])
      .then(data => data);
  }

  listIncidentsDtlById(body: any) {
    return this.httpClient.post<any>(this.INCIDENTS_LISTINCIDENTSDTLBYID, body)
      .toPromise()
      .then(res => res as IncidentsDtl[])
      .then(data => data);
  }
  findByIncidentId(body: any) {
    return this.httpClient.post<any>(this.INCIDENTS_FINDBYINCIDENTID, body)
      .toPromise()
      .then(res => res as IncidentsDocument)
      .then(data => data);
  }
  getFileSantoApp(body: any) {
    return this.httpClient.post<any>(this.FILES_GETFILESANTOAPP, body)
      .toPromise()
      .then(res => res as ResponseFile)
      .then(data => data);
  }

  async getFileBinSantoApp(body: any) {
    return this.httpClient.post(this.FILES_GETFILEBINSANTOAPP, body, { responseType: "blob" })
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getListFileSantoApp(body: any) {
    return this.httpClient.post<any>(this.FILES_GETLISTFILESANTOAPP, body)
      .toPromise()
      .then(res => res as ResponseFile[])
      .then(data => data);
  }
  createIncidentsDtl(body: any) {
    return this.httpClient.post<any>(this.INCIDENTSDTL_CREATE, body)
      .toPromise()
      .then(res => res as IncidentsDtl)
      .then(data => data);
  }
  updateIncidentsDtl(body: any) {
    return this.httpClient.put<any>(this.INCIDENTSDTL_UPDATE, body)
      .toPromise()
      .then(res => res as IncidentsDtl)
      .then(data => data);
  }
  updateIncidents(body: any) {
    return this.httpClient.put<any>(this.INCIDENTS_UPDATEINCIDENT, body)
      .toPromise()
      .then(res => res as IncidentsDocument)
      .then(data => data);
  }
  saveFileSantoApp(body: any) {
    return this.httpClient.post<any>(this.FILES_SAVEFILESANTOAPP, body)
      .toPromise()
      .then(res => res as ResponseFile)
      .then(data => data);

  }
  getAllUsersSupport() {
    return this.httpClient.get<any>(this.USERSSUPPORT_GETALL)
      .toPromise()
      .then(res => res as UsersSupportWrapperVO)
      .then(data => data);
  }
  findUsersSupportByUserId(body: any) {
    return this.httpClient.post<any>(this.USERSSUPPORT_FINDBYUSERID, body)
      .toPromise()
      .then(res => res as UsersSupportWrapperVO)
      .then(data => data);
  }
  listIncidentsAssignedTo(strDate?: string, endDate?: string, assignedTo?: string) {
    let params = new HttpParams();
    // if(strDate){
    params = params.append("strDate", strDate);
    params = params.append("endDate", endDate);
    params = params.append("assignedTo", assignedTo);
    //}
    return this.httpClient.get<any>(this.INCIDENTS_INCIDENTS_ASSIGNEDTO, { params: params })
      .toPromise()
      .then(res => res as IncidentsAsigned[])
      .then(data => data);
  }
  createUpdateOptionsAssist(body: any) {
    return this.httpClient.post<any>(this.OPTIONSASSIST_CREATE_UPDATE, body)
      .toPromise()
      .then(res => res as OptionsAssistDocument)
      .then(data => data);
  }

  getOptionsAssistByKey(body: any) {
    return this.httpClient.post<any>(this.OPTIONSASSIST_GET_BY_KEY, body)
      .toPromise()
      .then(res => res as OptionsAssistDocument)
      .then(data => data);
  }

  operetaionPeriodStore(supStoreId?: string, storeId?: string, operator?: string) {

    let params = new HttpParams();
    params = params.append("supStoreId", supStoreId);
    params = params.append("storeId", storeId);
    params = params.append("operator", operator);

    return this.httpClient.get<any>(this.OPERATION_STORED_PERIOD, { params: params })
      .toPromise()
      .then(res => res as LstStorePeriodResponse)
      .then(data => data);
  }

  getListStore(supStoreId?: string, year?: string, period?: string) {

    let params = new HttpParams();
    params = params.append("supStoreId", supStoreId);
    params = params.append("year", year);
    params = params.append("period", period);

    return this.httpClient.get<any>(this.GET_LIST_STORES, { params: params })
      .toPromise()
      .then(res => res as LstStoreResponse)
      .then(data => data);
  }

  getStoreById(body: any) {
    return this.httpClient.post<any>(this.GET_STORE_BYID, body)
      .toPromise()
      .then(res => res as Store)
      .then(data => data);
  }

  getOptionsRulesByOption(body: any) {
    return this.httpClient.post<any>(this.GET_OPTION_RULES_BY_OPTION, body)
      .toPromise()
      .then(res => res as OptionsRulesDocument[])
      .then(data => data);
  }

  createOptionsRules(body: any) {
    return this.httpClient.post<any>(this.CREATE_OPTION_RULES, body)
      .toPromise()
      .then(res => res as OptionsRulesDocument)
      .then(data => data);
  }

  updateOptionsRules(body: any) {
    return this.httpClient.put<any>(this.UPDATE_OPTION_RULES, body)
      .toPromise()
      .then(res => res as OptionsRulesDocument)
      .then(data => data);
  }

  deleteOptionsRules(body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.DELETE_OPTION_RULES, options)
      .toPromise()
      //.then(res => res as OptionsRulesDocument)
      .then(data => data);
  }

  createUserSupport(body: any) {
    return this.httpClient.post<any>(this.CREATE_USER_SUPPORT, body)
      .toPromise()
      .then(res => res as UsersSupportWrapperVO)
      .then(data => data);
  }

  updateUserSupport(body: any) {
    return this.httpClient.put<any>(this.UPDATE_USER_SUPPORT, body)
      .toPromise()
      .then(res => res as UsersSupportWrapperVO)
      .then(data => data);
  }

  deleteUserSupport(body: any) {
    return this.httpClient.post<any>(this.DELETE_USER_SUPPORT, body)
      .toPromise()
      //.then(res => res as UsersSupportWrapperVO)
      .then(data => data);
  }

  getParticipantsByServices(wrksId?: string) {

    let params = new HttpParams();
    params = params.append("wrksId", wrksId);
    return this.httpClient.get<any>(this.GET_PARTICIPANT_BY_SERVICES, { params: params })
      .toPromise()
      .then(res => res as Participant[])
      .then(data => data);
  }


  getDetailForm0(body: any) {
    return this.httpClient.post<any>(this.GET_DETAIL_FORM0, body)
      .toPromise()
      .then(res => res as Form0ChurchAdress)
      .then(data => data);
  }
  findWorkShopsDetailByID(body: any) {
    return this.httpClient.post<any>(this.FIND_WORKSHOPSDETAI_BYID, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  createWSParticipantWrp(body: any) {
    return this.httpClient.post<any>(this.CREATE_PARTICIPANT_FORM0, body)
      .toPromise()
      .then(res => res as WsParticipantsWrpVO)
      .then(data => data);
  }

  deleteParticipantForm0(body: any) {
    return this.httpClient.post<any>(this.DELETE_PARTICIPANT_FORM0
      , body)
      .toPromise()
      .then(res => res as ResponseVO)
      .then(data => data);
  }


  getStatesByCountry(countryId?: string) {

    let params = new HttpParams();
    params = params.append("id", countryId);
    return this.httpClient.get<any>(this.GET_STATE_BY_COUNTRY, { params: params })
      .toPromise()
      .then(res => res as State[])
      .then(data => data);
  }

  getAdressById(body: any) {
    return this.httpClient.post<any>(this.GET_ADDRESS_BY_ID, body)
      .toPromise()
      .then(res => res as Address)
      .then(data => data);
  }

  getSessionByServices(wrksId?: string, language?: string) {

    let params = new HttpParams();
    params = params.append("wrksId", wrksId);
    params = params.append("language", language);
    return this.httpClient.get<any>(this.GET_SESSIONS_FORM0, { params: params })
      .toPromise()
      .then(res => res as WrkSessAssist[])
      .then(data => data);
  }

  getListPartSessionByService(wrksId?: string, session?: string) {

    let params = new HttpParams();
    params = params.append("wrksId", wrksId);
    params = params.append("session", session);
    return this.httpClient.get<any>(this.GET_PART_BY_SERVICE_SESS, { params: params })
      .toPromise()
      .then(res => res as ParticipantServiceSession[])
      .then(data => data);
  }

  registerAssistanceParticipant(body: any) {
    return this.httpClient.post<any>(this.REGISTER_ASSIST_PARTICIPANT, body)
      .toPromise()
      .then(res => res as WSSessDate)
      .then(data => data);
  }
  listHstGuides(body: any) {
    return this.httpClient.post<any>(this.LIST_HST_GUIDES, body)
      .toPromise()
      .then(res => res as GuidesResponseVO[])
      .then(data => data);
  }
  searchWorkShop(body: any) {
    return this.httpClient.post<any>(this.LIST_WRKS_BY_GUIDETYPE, body)
      .toPromise()
      .then(res => res as WrksResponseVO[])
      .then(data => data);
  }
  listGuidesPartiInService(body: any) {
    return this.httpClient.post<any>(this.LIST_GUIDES_PART_INSERVICE, body)
      .toPromise()
      .then(res => res as WrksParcipResVO[])
      .then(data => data);
  }
  registerAssistanceDate(body: any) {
    return this.httpClient.post<any>(this.REGISTER_DATE_ASSIST, body)
      .toPromise()
      .then(res => res as WSSessDate)
      .then(data => data);
  }

  getValidPeriods(language?: string) {
    let params = new HttpParams();
    params = params.append("language", language);
    return this.httpClient.get<any>(this.GET_VALID_PERIODS, { params: params })
      .toPromise()
      .then(res => res as PeriodsVO[])
      .then(data => data);
  }
  getValidYears() {
    return this.httpClient.get<any>(this.GET_VALID_YEARS)
      .toPromise()
      .then(res => res as PeriodsVO[])
      .then(data => data);
  }
  getDependetLocalStores(body: any) {
    return this.httpClient.post<any>(this.GET_DEPENDENT_OCAL_STORES, body)
      .toPromise()
      .then(res => res as string[])
      .then(data => data);
  }

  getGuidesByZoneStatistics(body: any) {
    return this.httpClient.post<any>(this.GET_GUIDES_BY_ZONE_STS, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  createListExternGuides(body: any) {
    return this.httpClient.post<any>(this.CREATE__LIST_EXTERN_GUIDES, body)
      .toPromise()
      .then(res => res as ExternGuidesDocument[])
      .then(data => data);
  }

  getGuideById(body: any) {
    return this.httpClient.post<any>(this.GET_GUIDE_BY_ID, body)
      .toPromise()
      .then(res => res as GuideModel)
      .then(data => data);
  }

  updateGuide(body: any) {
    return this.httpClient.put<any>(this.UPDATE_GUIDE, body)
      .toPromise()
      .then(res => res as GuideModel)
      .then(data => data);
  }

  getTracingWorkShop(body: any) {
    return this.httpClient.post<any>(this.GET_TRACING_WORKSHOP, body)
      .toPromise()
      .then(res => res as TracingWokrshopsVO[])
      .then(data => data);
  }

  getTracingListWorkShop(body: any) {
    return this.httpClient.post<any>(this.GET_LIST_TRACING_WORKSHOP, body)
      .toPromise()
      .then(res => res as Workshops01VO[])
      .then(data => data);
  }
  getCurrentIntItemsPrc(body: any) {
    return this.httpClient.post<any>(this.GET_CURRENT_INT_ITEM_PRICE, body)
      .toPromise()
      .then(res => res as ItemsCurrentPriceVO[])
      .then(data => data);
  }
  getCurrentItemsPrc(body: any) {
    return this.httpClient.post<any>(this.GET_CURRENT_ITEM_PRICE, body)
      .toPromise()
      .then(res => res as ItemsCurrentPriceVO[])
      .then(data => data);
  }
  getGuideBalance(body: any) {
    return this.httpClient.post<any>(this.GET_GUIDE_BALANCE, body)
      .toPromise()
      .then(res => res as BalanceVO[])
      .then(data => data);
  }
  getPurchItemsToDownload(body: any) {
    return this.httpClient.post<any>(this.GET_PURCH_ITM_TO_DOWNLOAD, body)
      .toPromise()
      .then(res => res as PurchDowloadsVO[])
      .then(data => data);
  }
  createFileCtl(body: any) {
    return this.httpClient.post<any>(this.CREATE_FILECTL, body)
      .toPromise()
      .then(res => res as FileCtl[])
      .then(data => data);
  }
  updateFileCtl(body: any) {
    return this.httpClient.post<any>(this.UPDATE_FILECTL, body)
      .toPromise()
      .then(res => res as FileCtl[])
      .then(data => data);
  }
  listItemsTrackByItemAlbum(body: any) {
    return this.httpClient.post<any>(this.LIST_ITEMSTRACK_BYITEMALBUM, body)
      .toPromise()
      .then(res => res as ItemsTrack[])
      .then(data => data);
  }
  listItemsTrackByItemLanguage(body: any) {
    return this.httpClient.post<any>(this.LIST_ITEMSTRACK_BYITEMALBUMLANG, body)
      .toPromise()
      .then(res => res as ItemsTrack[])
      .then(data => data);
  }
  createItemsTrack(body: any) {
    return this.httpClient.post<any>(this.CREATE_ITEMSTRACK, body)
      .toPromise()
      .then(res => res as ItemsTrack)
      .then(data => data);
  }
  updateItemsTrack(body: any) {
    return this.httpClient.put<any>(this.UPDATE_ITEMSTRACK, body)
      .toPromise()
      .then(res => res as ItemsTrack)
      .then(data => data);
  }
  getItemsTrackById(body: any) {
    return this.httpClient.post<any>(this.GET_ITEMSTRACK_BYID, body)
      .toPromise()
      .then(res => res as ItemsTrack)
      .then(data => data);
  }
  getItemById(body: any) {
    return this.httpClient.post<any>(this.GET_ITEM_BYID, body)
      .toPromise()
      .then(res => res as Item)
      .then(data => data);
  }
  getItemByIdLang(body: any) {
    return this.httpClient.post<any>(this.GET_ITEM_BYID_LANG, body)
      .toPromise()
      .then(res => res as Item)
      .then(data => data);
  }
  deleteItemsTrack(body: any) {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.DELETE_ITEMSTRACK, options)
      .toPromise()
      //.then(res => res as OptionsRulesDocument)
      .then(data => data);


  }
  lstItmsAlbByItemLanguage(body: any) {
    return this.httpClient.post<any>(this.LIST_ITMALB_BYITMLANG, body)
      .toPromise()
      .then(res => res as ItemsAlbum[])
      .then(data => data);
  }
  getItemsAlbumById(body: any) {
    return this.httpClient.post<any>(this.GET_ITEMSALBUM_BYID, body)
      .toPromise()
      .then(res => res as ItemsAlbum)
      .then(data => data);
  }
  createItemsAlbum(body: any) {
    return this.httpClient.post<any>(this.CREATE_ITEMSALBUM, body)
      .toPromise()
      .then(res => res as ItemsAlbum)
      .then(data => data);
  }
  updateItemsAlbum(body: any) {
    return this.httpClient.put<any>(this.UPDATE_ITEMSALBUM, body)
      .toPromise()
      .then(res => res as ItemsAlbum)
      .then(data => data);
  }
  deleteItemsAlbum(body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.DELETE_ITEMSALBUM, options)
      .toPromise()
      .then(data => data);

  }
  getAssistHdrByLanguage(body: any) {
    return this.httpClient.post<any>(this.GET_ASSISTHDR_BYLANGUAGE, body)
      .toPromise()
      .then(res => res as AssistHdr[])
      .then(data => data);
  }
  getAssistDt1ByAssistId(body: any) {
    return this.httpClient.post<any>(this.GET_ASSISTDT1_BYASSISTID, body)
      .toPromise()
      .then(res => res as AssistDt1[])
      .then(data => data);
  }
  getAssistDt2ByAssistIdDt1(body: any) {
    return this.httpClient.post<any>(this.GET_ASSISTDT2_BYASSISTID_SEQDT1, body)
      .toPromise()
      .then(res => res as AssistDt2[])
      .then(data => data);
  }
  getAssistDt2ById(body: any) {
    return this.httpClient.post<any>(this.GET_ASSISTDT2_BYID, body)
      .toPromise()
      .then(res => res as AssistDt2)
      .then(data => data);
  }
  createAssistDt2(body: any) {
    return this.httpClient.post<any>(this.CREATE_ASSISTDT2, body)
      .toPromise()
      .then(res => res as AssistDt2)
      .then(data => data);
  }
  updateAssistDt2(body: any) {
    return this.httpClient.put<any>(this.UPDATE_ASSISTDT2, body)
      .toPromise()
      .then(res => res as AssistDt2)
      .then(data => data);
  }
  deleteAssistDt2(body: any) {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.DELETE_ASSISTDT2, options)
      .toPromise()
      //.then(res => res as OptionsRulesDocument)
      .then(data => data);

  }
  getAssistHdrById(body: any) {
    return this.httpClient.post<any>(this.GET_ASSISTHDR_BYID, body)
      .toPromise()
      .then(res => res as AssistHdr)
      .then(data => data);
  }
  getAssistDt1ById(body: any) {
    return this.httpClient.post<any>(this.GET_ASSISTDT1_BYID, body)
      .toPromise()
      .then(res => res as AssistDt1)
      .then(data => data);
  }
  sendMessages(body: any) {
    return this.httpClient.post<any>(this.SEND_MESSAGES, body)
      .toPromise()
      .then(res => res as Number)
      .then(data => data);
  }
  findUserByAnyId(body: any) {
    return this.httpClient.post<any>(this.FIND_USER_BY_ANYID, body)
      .toPromise()
      .then(res => res as User)
      .then(data => data);
  }
  getGuideMatPeriod(body: any) {
    return this.httpClient.post<any>(this.GET_GUIDE_MATERIAL_BYPERIOD, body)
      .toPromise()
      .then(res => res as GuideMatDtlVO[])
      .then(data => data);
  }
  getMaterialsBorrowByGuide(body: any) {
    return this.httpClient.post<any>(this.GET_MATERIALS_BORROWBY_GUIDE, body)
      .toPromise()
      .then(res => res as MaterialBorrow[])
      .then(data => data);
  }
  getBalanceByConceptDates(body: any) {
    return this.httpClient.post<any>(this.GET_BALANCE_BY_CONCEPT_DATES, body)
      .toPromise()
      .then(res => res as BalanceVO)
      .then(data => data);
  }
  getCategoryTranslation(body: any) {
    return this.httpClient.post<any>(this.CATEGORY_TRANSLATION, body)
      .toPromise()
      .then(res => res as string[])
      .then(data => data);
  }
  form0_findBy_Period_Guide(body: any) {
    return this.httpClient.post<any>(this.FORM0_FINDBY_PERIOD_GUIDE, body)
      .toPromise()
      .then(res => res as Form0[])
      .then(data => data);
  }
  getWstypeById(body: any) {
    return this.httpClient.post<any>(this.GET_WSTYPE_BYID, body)
      .toPromise()
      .then(res => res as Wstype)
      .then(data => data);
  }
  listTranslatedServices(body: any) {
    return this.httpClient.post<any>(this.LIST_TRANSLATED_SERVICES, body)
      .toPromise()
      .then(res => res as Wstype[])
      .then(data => data);
  }
  checkTransactionAccess(body: any) {
    return this.httpClient.post<any>(this.CHECK_TRANSACION_ACCESS, body)
      .toPromise()
      .then(res => res as GenericMessageVO)
      .then(data => data);
  }
  getAllAuthorityOpts() {
    return this.httpClient.get<any>(this.GET_ALL_AUTHORITYOPTS)
      .toPromise()
      .then(res => res as AuthorityOptsDocument[])
      .then(data => data);
  }
  createAuthorityOpts(body: any) {
    return this.httpClient.post<any>(this.CREATE_AUTHORITYOPTS, body)
      .toPromise()
      .then(res => res as AuthorityOptsDocument)
      .then(data => data);
  }
  updateAuthorityOpts(body: any) {
    return this.httpClient.put<any>(this.UPDATE_AUTHORITYOPTS, body)
      .toPromise()
      .then(res => res as AuthorityOptsDocument)
      .then(data => data);
  }

  getGuidesReport(body: any) {
    return this.httpClient.post<any>(this.GET_GUIDES_REPORT, body)
      .toPromise()
      .then(res => res as GuideReportVO[])
      .then(data => data);
  }

  getTovpilStructureTeam(body: any) {

    let params = new HttpParams();
    params = params.append("year", body.year);
    params = params.append("period", body.period);
    params = params.append("language", body.language)

    return this.httpClient.get<any>(this.GET_TOVPIL_STRUCTURE_TEAM, { params: params })
      .toPromise()
      .then(res => res as TreeNodeTovpil[])
      .then(data => data);
  }

  findZoneProductionOrders(body: any) {
    return this.httpClient.post<any>(this.FIND_ZONE_PRODUCTION_ORDERS, body)
      .toPromise()
      .then(res => res as PurchasingSum[])
      .then(data => data);
  }

  findWorkShopGuide(body: any) {
    return this.httpClient.post<any>(this.GET_WORKSHOPS_GUIDE, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  findWorkShopsByGuideId(body: any) {
    return this.httpClient.post<any>(this.FIND_WORKSHOPS_BYGUIDEID, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  getChurchsByCountryState(body: any) {
    return this.httpClient.post<any>(this.GET_CHURCH_BY_COUNTRY_STATE, body)
      .toPromise()
      .then(res => res as ChurchAdressVO[])
      .then(data => data);
  }

  getGuidesByStore(body: any) {
    return this.httpClient.post<any>(this.GET_GUIDES_BY_STORE, body)
      .toPromise()
      .then(res => res as GuideModel[])
      .then(data => data);
  }
  listPartnerGuides(body: any) {
    return this.httpClient.post<any>(this.LIST_PARTNER_GUIDES, body)
      .toPromise()
      .then(res => res as GuideModel[])
      .then(data => data);
  }

  listWstypeByGuideType(body: any) {
    return this.httpClient.post<any>(this.GET_WORKSHOPS_TYPE_BY_GUIDE, body)
      .toPromise()
      .then(res => res as Wstype[])
      .then(data => data);
  }

  updatePassword(body: any) {
    return this.httpClient.post<any>(this.UPDATE_PASSWORD, body)
      .toPromise()
      .then(res => res as string)
      .then(data => data);
  }

  createWorkShop(body: Form0) {
    return this.httpClient.post<any>(this.CREATE_WORKSHOP_GUIDE, body)
      .toPromise()
      .then(res => res as Form0)
      .then(data => data);
  }

  updateWorkShop(body: Form0) {
    return this.httpClient.put<any>(this.UPDATE_WORKSHOP_GUIDE, body)
      .toPromise()
      .then(res => res as Form0)
      .then(data => data);
  }

  deleteWorkShop(body: Form0) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.DELETE_WORKSHOP_GUIDE, options)
      .toPromise()
      .then(res => res as Form0)
      .then(data => data);
  }

  getListSpkLangByStoreId(body: any) {
    return this.httpClient.post<any>(this.get_List_Spk_Lang_ByStoreId, body)
      .toPromise()
      .then(res => res as ValuesVO[])
      .then(data => data);
  }

  getListAssitanceWorkshop(body: any) {

    let params = new HttpParams();
    params = params.append("wrksId", body.wrksId);
    params = params.append("language", body.language)

    return this.httpClient.get<any>(this.GET_LIST_ASSITANCE_WRK, { params: params })
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  ListFGByServiceAllSession(body: any) {
    return this.httpClient.post<any>(this.LIST_FG_SERVICE_ALL_SESSIONS, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  createUpdateCancelForm0Wrp(body: any) {
    return this.httpClient.post<any>(this.CREATEUPDATECANCEL_FORM0WRP, body)
      .toPromise()
      .then(res => res as Form0WrpVO)
      .then(data => data);
  }

  createUpdateAssitanceWorkShop(body: any) {
    return this.httpClient.post<any>(this.CREATE_UPDATE_ASSITANCE_WORKSHOP, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  createUpdateListFGAttendande(body: any) {
    return this.httpClient.post<any>(this.CREATE_UPDATE_LIST_GF_ATTENDANCE, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  passwordRecover(body: any) {
    return this.httpClient.post<any>(this.PASSWORD_RECOVER, body)
      .toPromise()
      .then(res => res as ResponseVO)
      .then(data => data);
  }

  validateAccess_getGuideId(body: any) {
    return this.httpClient.post<any>(this.VALIDATE_ACCESS_GETGUIDEID, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  createUser(body: any) {
    return this.httpClient.post<any>(this.CREATE_USER, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getListChurches(body: any) {
    return this.httpClient.post<any>(this.GET_LIST_CHURCHES_FILTER, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  findChurchsByCountryStateUser(body: any) {
    return this.httpClient.post<any>(this.GET_LIST_CHURCHES__STATEUSER_FILTER, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  getGuideProfile(body: any) {
    let params = new HttpParams();
    params = params.append("guideId", body.guideId);

    return this.httpClient.get<any>(this.GET_GUIDE_PROFILE, { params: params })
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  getCitiesFromState(body: any) {
    return this.httpClient.post<any>(this.GET_CITIES_FROM_STATE, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  crudChurch(body: any) {
    return this.httpClient.post<any>(this.CRUD_CHURCH, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  findPurchItmDwnByStore(body: any) {
    return this.httpClient.post<any>(this.FIND_PURCHITMDWN_BYSTORE, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  getCreateUpdatePurchItmDwn(body: any) {
    return this.httpClient.post<any>(this.CRUD_PURCHITMDWN, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  listTranslatedItems(body: any) {
    return this.httpClient.post<any>(this.LIST_TRANSLATED_ITEMS, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  findPurchItmDwnByPassKey(body: any) {
    return this.httpClient.post<any>(this.FIND_PURCHITMDWN_BYPASSKEY, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  getPurchItmDwnById(body: any) {
    return this.httpClient.post<any>(this.GET_PURCHITMDWN_BYID, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  deletePurchItmDwn(body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.DELETE_PURCHITMDWN, options)
      .toPromise()
      //.then(res => res as OptionsRulesDocument)
      .then(data => data);
  }
  findPurchItmDwnByGuideId(body: any) {
    return this.httpClient.post<any>(this.FIND_PURCHITMDWN_BYGUIDEID, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  findPurchItmDwnByGuideIdAvailable(body: any) {
    return this.httpClient.post<any>(this.FIND_PURCHITMDWN_BYGUIDEID_AVAILABLE, body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  getAllSchoolFpg(body: any) {
    return this.httpClient.post<any>(this.GET_ALL_SCHOOLFPG, body)
      .toPromise()
      .then(res => res as SchoolFpgDataVO[])
      .then(data => data);
  }

  crudSchoolFpg(body: any) {
    return this.httpClient.post<any>(this.GET_ALL_SCHOOLFPG_CRUD, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  listDependetLocalStores(body: any) {
    return this.httpClient.post<any>(this.LIST_DEPENDENT_LOCAL_STORES, body)
      .toPromise()
      .then(res => res as Store[])
      .then(data => data);
  }

  getListSchoolEnrollFGGuideAndAddress(params: any) {
    return this.httpClient.post<any>(this.GET_PARTICIPANT_SCHOOLFPG_BY_SERVICES, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  getCreateUpdateCancelSchoolEnrollFG(params: any) {
    return this.httpClient.post<any>(this.GET_CREATE_UPDATE_CANCE_SCHOOLENROOLFG, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  findOpenSchoolsByGuideId(params: any) {
    return this.httpClient.post<any>(this.FIND_OPEN_SCHOOL_BY_GUIDE, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  updateSchoolFPG(params: any) {
    return this.httpClient.put<any>(this.UPDATE_SCHOOLFPG, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  changeSchoolStatus(body: any) {
    return this.httpClient.post<any>(this.CHANGE_SCHOOL_STATUS, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  changeWrksStatus(body: any) {
    return this.httpClient.post<any>(this.CHANGE_WRKS_STATUS, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  getChurchAdressById(body: any) {
    return this.httpClient.post<any>(this.GET_CHURCH_ADDRESS_BYID, body)
      .toPromise()
      .then(res => res as ChurchAdressVO)
      .then(data => data);
  }
  changeStatusGuide(params: any) {
    return this.httpClient.post<any>(this.CHANGE_STATUS_GUIDE, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  schoolFpgSendGuide(params: any) {
    return this.httpClient.post<any>(this.SCHOOLFPG_PARTICIPANT_SEND_GUIDE, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  listStatusGuide(params: any) {
    return this.httpClient.post<any>(this.LIST_STATUS_GUIDE, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  listWorkShopsByStoreId(params: any) {
    return this.httpClient.post<any>(this.LIST_WORKSHOP_BY_STORE_ID, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  getStatusTransitionRules(body: any) {
    return this.httpClient.post<any>(this.GET_STATUS_TRANSITION_RULES, body)
      .toPromise()
      .then(res => res as ValuesVO[])
      .then(data => data);
  }

  createVersionHistoryEntry(body: any): Promise<VersionHistory> {
    return this.httpClient.post<any>(this.CREATE_VERSION_HISTORY_URL, body)
      .toPromise()
      .then(res => res as VersionHistory)
      .catch(error => {
        console.error('Error creating version history:', error);
        throw error;
      });
  }

  getAllVersionHistoryEntries(body: any): Promise<VersionHistory[]> {
    return this.httpClient.get<any[]>(this.GET_ALL_VERSION_HISTORY_URL)
      .toPromise()
      .then(res => res as VersionHistory[])
      .catch(error => {
        console.error('Error getting all version history:', error);
        throw error;
      });
  }
  getCoutriesFromStore(body: any) {
    return this.httpClient.post<any>(this.GET_COUNTRIES_FROMSTORE, body)
      .toPromise()
      .then(res => res as CountryModel[])
      .then(data => data);
  }

  deleteVersionHistoryEntry(body: any): Promise<VersionHistory> {
    return this.httpClient.delete<any>(this.DELETE_VERSION_HISTORY_URL, body)
      .toPromise()
      .then(res => res as VersionHistory)
      .catch(error => {
        console.error('Error deleting version history:', error);
        throw error;
      });
  }
  updateVersionHistoryEntry(body: any): Promise<VersionHistory> {
    return this.httpClient.put<any>(this.UPDATE_VERSION_HISTORY_URL, body)
      .toPromise()
      .then(res => res as VersionHistory)
      .catch(error => {
        console.error('Error updating version history:', error);
        throw error;
      });
  }

  getListFgHistorialChanges(params: any) {
    return this.httpClient.post<any>(this.GET_FG_HISTORIAL_CHANGES, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  findPurchordhByStoreId(params: any) {
    return this.httpClient.post<any>(this.FIND_PO_BY_STOREID, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  findPurchordhBysupplStoreId(params: any) {
    return this.httpClient.post<any>(this.FIND_PO_BY_SUPPL_STOREID, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  lstSuppliersBySupStoreId(params: any) {
    return this.httpClient.post<any>(this.LIST_SUPPLIERS_BY_SUPSTOREID, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  getPurchordhOrderRequest(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "materials/getPurchordhOrderRequest", params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  getListCurrencyByStoreId(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/getListCurrencyByStoreId", params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  createUpdateDeletePurchordd(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "materials/createUpdateDeletePurchordd", params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  lstCordinationCatalog(params: any) {
    return this.httpClient.post<any>(this.LIST_CORDINATION_CATALOGS, params)
      .toPromise()
      .then(res => res as StructureNodeVO[])
      .then(data => data);
  }
  purchOrdHChgSts(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "materials/purchOrdHChgSts", params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  //creado por Eduardo
  getUsers() {
    return this.httpClient.get<any>(this.SERVER_URL + "catalogs/getUsers")
      .toPromise()
      //.then(res => res as Usuario)
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  updateUser(body: any) {
    return this.httpClient.put<any>(this.SERVER_URL + "catalogs/updateUser", body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  createUser2(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/createUser", body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  //Creado por Eduardo Cevero
  deleteUser(body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.SERVER_URL + "catalogs/deleteUser", options)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  listCategoryTranslation(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/listCategoryTranslation", body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  listUsersByLevelStore(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/listUsersByLevelStore", body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  listAllDataGuidesbySupStore(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/listAllDataGuidesbySupStore", body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  //Creado por Eduardo Cevero
  getAllSupplier() {
    return this.httpClient.get<any>(this.SERVER_URL + "catalogs/getAllSupplier")
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  updatePurchordhOrderInventory(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "materials/updatePurchordhOrderInventory", body)
      .toPromise()
      .then(res => res as ResponseVO)
      .then(data => data);
  }
  changeUserStatus(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/changeUserStatus", body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getDynQuery(body: any) {
    return this.httpClient.post<any>(this.LIST_GETDYN_QUERY, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  updateSupplier(body: any) {
    return this.httpClient.put<any>(this.SERVER_URL + "catalogs/updateSupplier", body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  createSupplier(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/createSupplier", body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  deleteSupplier(body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.SERVER_URL + "catalogs/deleteSupplier", options)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  recoverLink(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "event/recoverLink", body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  getFiiconceptById(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "treasurer/getFiiconceptById", body)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  listFiiconcept(params) {
    return this.httpClient.get<any>(this.SERVER_URL + "treasurer/listFiiconcept?lan=" + params.lang)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  createFiiconcept(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "treasurer/createFiiconcept", body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  //Creado por Eduardo Cevero
  updateFiiconcept(body: any) {
    return this.httpClient.put<any>(this.SERVER_URL + "treasurer/updateFiiconcept", body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getFiiconceptlangId(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "treasurer/getFiiconceptlangId", body)
      .toPromise()
      .then(res => res as FiiConceptLang[])
      .then(data => data);
  }

  createFiiconceptlang(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "treasurer/createFiiconceptlang", body)
      .toPromise()
      .then(res => res as FiiConceptLang)
      .then(data => data);
  }

  updateFiiconceptlang(body: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "treasurer/createFiiconceptlang", body)
      .toPromise()
      .then(res => res as FiiConceptLang)
      .then(data => data);
  }

  deleteFiiconceptlang(body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.SERVER_URL + "treasurer/deleteFiiconceptlang", options)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getCountryPriceList(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "materials/findCountryLists", params)
      .toPromise()
      .then(res => res as CountryPrice[])
      .then(data => data);
  }

  getListPriceInt(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "materials/lstPriceListInt", params)
      .toPromise()
      .then(res => res as PriceListInt[])
      .then(data => data);
  }

  getListPriceZone(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "materials/lstZonePriceList", params)
      .toPromise()
      .then(res => res as PriceListZone[])
      .then(data => data);
  }

  getCountryById(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/getCountryById", params)
      .toPromise()
      .then(res => res as CountryVO)
      .then(data => data);
  }
  getCategories() {
    return this.httpClient.get<any>(this.GET_CATEGORY)
      .toPromise()
      .then(res => res as Category[])
      .then(data => data);
  }

  getFindAllByLanguage(params: any) {
    return this.httpClient.post<any>(this.FIND_ALL_BY_LANGUAGE, params)
      .toPromise()
      .then(res => res as ListPrice[])
      .then(data => data);
  }

  findMaxExchangeRate(params: any) {
    return this.httpClient.post<any>(this.FIND_MAX_EXCHANGE_RATE, params)
      .toPromise()
      .then(res => res as ExchangeRate)
      .then(data => data);
  }

  createPriceListInt(params: any) {
    return this.httpClient.post<any>(this.CREATE_PRICE_LIST_INT, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  updatePriceListInt(body: any) {
    return this.httpClient.put<any>(this.UPDATE_PRICE_LIST_INT, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getPriceListIntById(params: any) {
    return this.httpClient.post<any>(this.GET_PRICE_LIST_INT_BY_ID, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  updatePriceListIntH(body: any) {
    return this.httpClient.put<any>(this.UPDATE_PRICE_LIST_INT_H, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }


  getPriceListIntHById(params: any) {
    return this.httpClient.post<any>(this.GET_PRICE_LIST_INT_H_BY_ID, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  updateCategory(body: any) {
    return this.httpClient.put<any>(this.UPDATE_CATEGORY_BY_ID, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  createPriceListInth(params: any) {
    return this.httpClient.post<any>(this.CREATE_PRICE_LIST_INT_H, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  clonePriceListById(params: any) {
    return this.httpClient.post<any>(this.CLONE_PRICE_LIST_INT_BY_ID, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  findByCountryCurrLang(params: any) {
    return this.httpClient.post<any>(this.FIND_BY_COUNTRY_CURR_LANG, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  markAsSelectedPriceListZ(params: any) {
    return this.httpClient.post<any>(this.MARK_AS_SELECTED_PRICE_LISTZ, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  updatePriceListZ(body: any) {
    return this.httpClient.put<any>(this.UPDATE_PRICE_LISTZ, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  getPriceListById(params: any) {
    return this.httpClient.post<any>(this.GET_PRICE_LIST_BY_ID, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  updatePriceListZone(body: any) {
    return this.httpClient.put<any>(this.UPDATE_PRICE_LIST_ZONE, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  createPriceListZone(params: any) {
    return this.httpClient.post<any>(this.CREATE_PRICE_LIST_ZONE, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getStoreMaterialsByCountry(params: any) {
    return this.httpClient.post<any>(this.GET_STORE_MATERIALS_BY_COUNTRY, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getCountryMaterials(params: any) {
    return this.httpClient.post<any>(this.GET_COUNTRY_MATERIALS, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  listItemsStoreCountry(params: any) {
    return this.httpClient.post<any>(this.LIST_ITEMS_STORE_COUNTRY, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  createUpdatePriceListDetail(params: any) {
    return this.httpClient.post<any>(this.CREATE_UPDATE_PRICE_LIST_ZONE, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  findPropertiesByKey(params: any) {
    return this.httpClient.post<any>(this.FIND_PROPERTIES_BY_KEY, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  getCountrySpkLangByCountryId(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/getCountrySpkLangByCountryId", params)
      .toPromise()
      .then(res => res as ValuesVO[])
      .then(data => data);
  }
  dwdCurrentPriceList(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "materials/dwdCurrentPriceList", params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  dwnFIOffering(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "secretary/dwnFIOffering", params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  dwdCurrentPriceZone(params: any) {
    return this.httpClient.post<any>(this.DWD_CURRENT_PRICE_ZONE, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getGuidesByYearAndPeriod(params: any) {
    return this.httpClient.post<any>(this.GET_GUIDES_BY_YEAR_PERIOD, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getLoadServs(params: any) {
    return this.httpClient.post<any>(this.GET_LOAD_SERVS, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  getLoadAmount(params: any) {
    return this.httpClient.post<any>(this.GET_LOAD_AMOUNT, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getSalesCons(params: any) {
    return this.httpClient.post<any>(this.GET_LOAD_SALES_CONS, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  savePendAmount(params: any) {
    return this.httpClient.post<any>(this.GET_SAVE_PEND_AMOUNT, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getMaterialRequest(params: any) {
    return this.httpClient.post<any>(this.GET_MATERIAL_REQUEST, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  updateMaterialRequest(body: any) {
    return this.httpClient.put<any>(this.UPDATE_MATERIAL_REQUEST, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  deleteMaterialRequest(body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.DELETE_MATERIAL_REQUEST, options)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  listFGInShool(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/listFGInShool", params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  getGuideReqMat(params: any) {
    return this.httpClient.post<any>(this.GET_GUIDE_REQ_MAT, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  getGuideSelectedPriceLst(params: any) {
    return this.httpClient.post<any>(this.GET_SELECTED_PRICE_LIST, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  findPeriodGuideDescrip(params: any) {
    return this.httpClient.post<any>(this.FIND_BY_PERIOD_GUIDE_DESCRIP, params)
      .toPromise()
      .then(res => res as any[])
      .then(data => data);
  }

  searchCategory(params: any) {
    return this.httpClient.post<any>(this.BUSCA_CATEGORY, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getPublicPackLstPrice(params: any) {
    return this.httpClient.post<any>(this.GET_PUBLIC_PACK_LIST_PRICE, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getLocMatCtlH(params: any) {
    return this.httpClient.post<any>(this.GET_LOCMATCTL_H, params)
      .toPromise()
      .then(res => res as LocMatCtlH)
      .then(data => data);
  }

  // updateCreateLocMatCtlH(params: any) {
  //   return this.httpClient.post<any>(this.UPDATE_CREATE_LOCMATCTL_H, params)
  //     .toPromise()
  //     .then(res => res as LocMatCtlH)
  //     .then(data => data);
  // }

  getLocMatCtlM(params: any) {
    return this.httpClient.post<any>(this.GET_LOCMATCTL_M, params)
      .toPromise()
      .then(res => res as LocMatCtlM)
      .then(data => data);
  }

  updateCreateLocMatCtlM(params: any) {
    return this.httpClient.post<any>(this.UPDATE_CREATE_LOCMATCTL_M, params)
      .toPromise()
      .then(res => res as LocMatCtlM)
      .then(data => data);
  }

  getLocMatCtlD(params: any) {
    return this.httpClient.post<any>(this.GET_LOCMATCTL_D, params)
      .toPromise()
      .then(res => res as LocMatCtlD)
      .then(data => data);
  }

  updateCreateLocMatCtlD(params: any) {
    return this.httpClient.post<any>(this.UPDATE_CREATE_LOCMATCTL_D, params)
      .toPromise()
      .then(res => res as LocMatCtlD)
      .then(data => data);
  }

  listDependetGuideStores(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/listDependetGuideStores", params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  removeRecordLocmatcltM(params: any) {
    return this.httpClient.post<any>(this.REMOVE_RECORD_LOCMATCTL_M, params)
      .toPromise()
      .then(res => res as LocMatCtlM)
      .then(data => data);
  }

  getStatesFromStore(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/getStatesFromStore", params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getListOrderGuidesById(params: any) {
    return this.httpClient.post<any>(this.GET_LIST_ORDER_GUIDES_BY_ID, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  approveLocMatCtlInventory(params: any) {
    return this.httpClient.post<any>(this.APPROVE_LOCMATCTL_INVENTORY, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  // CX4
  getLstTreeChildStores(supStoreId?: string, onlySantov?: string) {
    let params = new HttpParams();
    params = params.append("supStoreId", supStoreId);
    params = params.append("onlySantov", onlySantov);

    return this.httpClient.get<any>(this.LST_TREE_CHILD_STORES, { params: params })
      .toPromise()
      .then(res => res as LCSelector[])
      .then(data => data);
  }

  getStoreByIdWithDescription(body: any) {
    return this.httpClient.post<any>(this.GET_STORE_WITH_DESCRIP, body)
      .toPromise()
      .then(res => res as Store)
      .then(data => data);
  }

  getFiiMonth(body: any) {
    return this.httpClient.post<any>(this.GET_FII_MONTHS, body)
      .toPromise()
      .then(res => res as FiiMonth[])
      .then(data => data);
  }

  getCheckOpenOrders(body: any) {
    return this.httpClient.post<any>(this.GET_CHECK_OPEN_ORDERS, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getGuideStoreAndLastname(body: any) {
    return this.httpClient.post<any>(this.GET_GUIDE_STORE_NAME_LASTNAME, body)
      .toPromise()
      .then(res => res as Guide[])
      .then(data => data);
  }

  getCreateUpdateDeleteFIIDtl(body: any) {
    return this.httpClient.post<any>(this.GET_CREATE_UPDATE_DELETE_FII_DTL, body)
      .toPromise()
      .then(res => res as FiiDtl)
      .then(data => data);
  }

  saveUserPreferences(body: any) {
    return this.httpClient.post<any>(this.SAVE_UPDATE_USER_PREFERENCES, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getUserPreferencesByStoreId(body: any) {
    return this.httpClient.post<any>(this.GET_USER_PREFERENCES, body)
      .toPromise()
      .then(res => res as UserPreferences)
      .then(data => data);
  }

  getCreateUpdateDeleteIncidents(body: any) {
    return this.httpClient.post<any>(this.CRUD_INCIDENTS, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  listFIIJournalDetailWithConcepts(body: any) {
    return this.httpClient.post<any>(this.GET_LIST_FII_JOURNAL_WITH_CONCEPT, body)
      .toPromise()
      .then(res => res as FiiJournalConcept[])
      .then(data => data);
  }
  getUserById(body: any) {
    return this.httpClient.post<any>(this.GET_USER_BY_ID, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  listFIIJournalSemesterWithConcepts(body: any) {
    return this.httpClient.post<any>(this.GET_LIST_FII_JOURNAL_SEMESTER_WITH_CONCEPT, body)
      .toPromise()
      .then(res => res as FiiJournalConcept[])
      .then(data => data);
  }

  listFIIJournalSummary(body: any) {
    return this.httpClient.post<any>(this.GET_LIST_FII_JOURNAL_SUMMARY, body)
      .toPromise()
      .then(res => res as FiiJournalSummary[])
      .then(data => data);
  }

  retrieveCommentsByDate(body: any) {
    return this.httpClient.post<any>(this.RETRIEVE_COMMENTS_BY_DATE, body)
      .toPromise()
      .then(res => res as CommentsF)
      .then(data => data);
  }

  createCommentsf(body: any) {
    return this.httpClient.post<any>(this.CREATE_COMMENTS_F, body)
      .toPromise()
      .then(res => res as CommentsF)
      .then(data => data);
  }


  findSecurityById(body: any) {
    return this.httpClient.post<any>(this.FIND_SECURITY_BY_ID, body)
      .toPromise()
      .then(res => res as SecurityDocument)
      .then(data => data);
  }

  updateSecurityById(body: any) {
    return this.httpClient.put<any>(this.UPDATE_SECURITY_BY_ID, body)
      .toPromise()
      .then(res => res as SecurityDocument)
      .then(data => data);
  }

  listJrnHGuideReferIncExp(body: any) {
    return this.httpClient.post<any>(this.GET_LIST_JRN_GUIDE_REFERINC, body)
      .toPromise()
      .then(res => res as FiiJournalSummary[])
      .then(data => data);
  }

  jrnHGuideReferIncExp(body: any) {
    return this.httpClient.post<any>(this.GET_JRN_GUIDE_REFERINC_EXP, body)
      .toPromise()
      .then(res => res as FiiJournalDetailConcept[])
      .then(data => data);
  }

  crudJrnhOffer(body: any) {
    return this.httpClient.post<any>(this.CRUD_JRNH_OFFER, body)
      .toPromise()
      .then(res => res as FiiDtl)
      .then(data => data);
  }

  listFvSummaryMatter(body: any) {
    return this.httpClient.post<any>(this.GET_LIST_SUMMARY_MATTER, body)
      .toPromise()
      .then(res => res as FVSummaryWrp[])
      .then(data => data);
  }



  listStatistForFI(body: any) {
    return this.httpClient.post<any>(this.LIST_STATIS_FOR_FI, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getCommentsfById(body: any) {
    return this.httpClient.post<any>(this.GET_COMMENTSF_BY_ID, body)
      .toPromise()
      .then(res => res as CommentsF)
      .then(data => data);
  }

  updateCommentsf(body: any) {
    return this.httpClient.put<any>(this.UPDATE_COMMENTSF_BY_ID, body)
      .toPromise()
      .then(res => res as CommentsF)
      .then(data => data);
  }

  approveSendJournalPer(body: any) {
    return this.httpClient.post<any>(this.APPROVE_SEND_JOURNAL, body)
      .toPromise()
      .then(res => res as ResponseVO)
      .then(data => data);
  }


  findSupStoreRelationship(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/findSupStoreRelationship", params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }


  getApproveRejectJournalPer(params: any) {
    return this.httpClient.post<any>(this.GET_APPROVE_REJECT_JOURNL_PER, params)
      .toPromise()
      .then(res => res as ResponseVO)
      .then(data => data);
  }

  findFiiJournalPerbyYear(params: any) {
    return this.httpClient.post<any>(this.FIND_FII_JOURNAL_PER_BY_YEAR, params)
      .toPromise()
      .then(res => res as JournalPerYear[])
      .then(data => data);
  }


  listFiiJournalDetailByConcept(params: any) {
    return this.httpClient.post<any>(this.GET_LIST_FII_JOURNAL_DETAIL_BY_CONCEPT, params)
      .toPromise()
      .then(res => res as FiiJournalDetailConcept[])
      .then(data => data);
  }

  listStoresToPay(params: any) {
    return this.httpClient.post<any>(this.GET_LIST_STORES_TO_PAY, params)
      .toPromise()
      .then(res => res as Store[])
      .then(data => data);
  }
  dwnRemitionXls(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "materials/dwnRemitionXls", params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  createUpdateListAttendBySession(params: any) {
    return this.httpClient.post<any>(this.CREATE_UPDATE_LIST_ATTEND_BY_SESSION, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  dwnFIIXls(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "treasurer/dwnFIIXls", params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }
  moveItemsTrack(params: any) {
    return this.httpClient.post<any>(this.SERVER_URL + "catalogs/moveItemsTrack", params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  listFVDetailMater(params: any) {
    return this.httpClient.post<any>(this.LST_FV_DETAIL_MATER, params)
      .toPromise()
      .then(res => res as FVDetailMater[])
      .then(data => data);
  }

  getRecpayById(params: any) {
    return this.httpClient.post<any>(this.GET_BY_REC_PAY, params)
      .toPromise()
      .then(res => res as RecPay)
      .then(data => data);
  }


  createRecpay(params: any) {
    return this.httpClient.post<any>(this.CREATE_REC_PAY, params)
      .toPromise()
      .then(res => res as RecPay)
      .then(data => data);
  }

  updateRecpay(params: any) {
    return this.httpClient.put<any>(this.UPDATE_REC_PAY, params)
      .toPromise()
      .then(res => res as RecPay)
      .then(data => data);
  }

  deleteRecpay(body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.DELETE_REC_PAY, options)
      .toPromise()
      .then(data => data);

  }

  dwdWorkshopsXls(params: any) {
    return this.httpClient.post<any>(this.DWD_WORKSHOPS_EXCEL, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  dwdSFPGSumaryXLS(params: any) {
    return this.httpClient.post<any>(this.DWD_SFPG_EXCEL, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getListDetailGuidesMat(params: any) {
    return this.httpClient.post<any>(this.GET_LIST_DETAIL_GUIDES_MAT, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getEmailsCtlById(email: string) {
    let params = new HttpParams();
    params = params.append("id", email);
    return this.httpClient.get<any>(this.GET_EMAIL_BY_EMAIL, { params: params })
      .toPromise()
      .then(res => res as EmailsDocument)
      .then(data => data);
  }

  updateEmails(params: any) {
    return this.httpClient.put<any>(this.EMAILS_UPDATE, params)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getAllStoreCurrency() {
    return this.httpClient.get<any>(this.GET_ALL_STORE_CURRENCY)
      .toPromise()
      .then(res => res as StoreCurrency[])
      .then(data => data);
  }

  createStoreCurrency(params: any) {
    return this.httpClient.post<any>(this.CREATE_STORE_CURRENCY, params)
      .toPromise()
      .then(res => res as StoreCurrency)
      .then(data => data);
  }

  updateStoreCurrency(body: any) {
    return this.httpClient.put<any>(this.UPDATE_STORE_CURRENCY, body)
      .toPromise()
      .then(res => res as StoreCurrency)
      .then(data => data);
  }

  deleteStoreCurrency(body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: body
    }
    return this.httpClient.delete<any>(this.DELETE_STORE_CURRENCY, options)
      .toPromise()
      .then(data => data);

  }

  getOnlyCoutryFromStore(params: any) {
    return this.httpClient.post<any>(this.GET_ONLY_COUNTRY_FROM_STORE, params)
      .toPromise()
      .then(res => res as CountryModel)
      .then(data => data);
  }

  listByEmails(body: any) {
    return this.httpClient.post<any>(this.LIST_BY_EMAILS, body)
      .toPromise()
      .then(res => res as EmailsDocument[])
      .then(data => data);
  }

  crudZoneCoords(body: any) {
    return this.httpClient.post<any>(this.CRUD_ZONE_COORD, body)
      .toPromise()
      .then(res => res as ZoneCoordWrapper)
      .then(data => data);
  }

  getZoneCoordById(body: any) {
    return this.httpClient.post<any>(this.GET_ZONE_COORD_BY_ID, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  getMaterialRequestOrderStatus(body: any) {
    return this.httpClient.post<any>(this.MATERIAL_REQUEST_ORDER_STATUS, body)
      .toPromise()
      .then(res => res as MatNatReqStsHVO[])
      .then(data => data);
  }

  getMaterialGetReqItemsQuantity(body: any) {
    return this.httpClient.post<any>(this.MATERIAL_GET_REQ_ITEMS_QTY, body)
      .toPromise()
      .then(res => res as MatNatItemQtyVO[])
      .then(data => data);
  }

  getItemsToApproveFromOrder(body: any) {
    return this.httpClient.post<any>(this.GET_ITEMS_TO_APPROVE_FROM_ORDER, body)
      .toPromise()
      .then(res => res as PurchItmDwnAppHVO)
      .then(data => data);
  }

  updatePurchItmDwn(body: PurchItmDwn) {
    return this.httpClient.put<any>(this.PURCH_ITEM_UPADTE, body)
      .toPromise()
      .then(res => res as PurchItmDwn)
      .then(data => data);
  }

  checkGrantAudioPlay(body: any) {
    return this.httpClient.post<any>(this.CHECK_GRANT_AUDIO_PLAY, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  createAddressbook(body: AddressBook) {
    return this.httpClient.post<any>(this.CREATE_ADDRESSBOOK, body)
      .toPromise()
      .then(res => res as AddressBook)
      .then(data => data);
  }


  updateAddressBook(body: AddressBook) {
    return this.httpClient.put<any>(this.UPDATE_ADDRESSBOOK, body)
      .toPromise()
      .then(res => res as AddressBook)
      .then(data => data);
  }

  getNatiosByZone(zoneId: string) {
    let params = new HttpParams();
    params = params.append("zoneId", zoneId);
    return this.httpClient.get<any>(this.GET_NATIOS_BY_ZONE, { params: params })
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  getLocalsByNatio(natioId: string) {
    let params = new HttpParams();
    params = params.append("natioId", natioId);
    return this.httpClient.get<any>(this.GET_LOCALS_BY_ZONE, { params: params })
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  crudNatioCoord(body: any) {
    return this.httpClient.post<any>(this.CRUD_NATIO_COORD, body)
      .toPromise()
      .then(res => res as NatioCoordWrapper)
      .then(data => data);
  }

  crudLocalCoord(body: any) {
    return this.httpClient.post<any>(this.CRUD_LOCAL_COORD, body)
      .toPromise()
      .then(res => res as LocalCoordWrapper)
      .then(data => data);
  }

  getNatioCoordById(body: any) {
    return this.httpClient.post<any>(this.GET_NATIO_COORD_BY_ID, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  getFileChunk(folderId: string, nameFile: string) {
    const body = { folderId, nameFile };
    return this.httpClient.post(this.DOWNLOAD_VIDEO, body, {
      observe: 'events', // Escucha eventos de progreso
      reportProgress: true, // Habilita el reporte de progreso
      responseType: 'blob', // Asegura que el tipo de respuesta sea un Blob
    });
  }

  getInternatItemsSalesByCategory(body: any) {
    return this.httpClient.post<any>(this.GET_INTERNAT_ITEMS_SALES_BY_CATEGORY, body)
      .toPromise()
      .then(res => res as IntItemSalesHdrVO[])
      .then(data => data);
  }

  findSupRelationByName(body: any) {
    return this.httpClient.post<any>(this.GET_FIND_SUP_RELATION_BY_NAME, body)
      .toPromise()
      .then(res => res as StoreSupRelationVO[])
      .then(data => data);
  }

  findSupRelationByStoreId(body: any) {
    return this.httpClient.post<any>(this.GET_FIND_SUP_RELATION_BY_STORE_ID, body)
      .toPromise()
      .then(res => res as StoreSupRelationVO)
      .then(data => data);
  }

  getPropertyValue(body: any) {
    return this.httpClient.post<any>(this.GET_PROPERTY_VALUE, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  openAssignedFolios(body: any) {
    return this.httpClient.post<any>(this.OPEN_ASSIGNED_FOLIOS, body)
      .toPromise()
      .then(res => res as OpenAssignedFolios)
      .then(data => data);
  }

  crudPropertiesDocument(body: any) {
    return this.httpClient.post<any>(this.CRUD_PROPERTIES, body)
      .toPromise()
      .then(res => res as PropertiesDocumentCrudWrapper)
      .then(data => data);
  }

  getGuideItemsToPlay(body: any) {
    return this.httpClient.post<any>(this.GET_GUIDE_ITEMS_TO_PLAY, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  listTranslatedItemsbyItemCat3(body: any) {
    return this.httpClient.post<any>(this.LIST_TRANSLATED_ITEMS_BY_ITEMCAT3, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  crudExternGuidesDocument(body: any) {
    return this.httpClient.post<any>(this.CRUD_EXTERN_GUIDE, body)
      .toPromise()
      .then(res => res as ExternGuideDocumentCrudWrapper)
      .then(data => data);
  }

  getFVSummary(body: any) {
    return this.httpClient.post<any>(this.GET_FV_SUMMARY, body)
      .toPromise()
      .then(res => res as CXC2HeaderWrapper)
      .then(data => data);
  }

  crudVideoService(body: any) {
    return this.httpClient.post<any>(this.CRUD_VIDEO_SERVICE, body)
      .toPromise()
      .then(res => res as VideoCollectionWrapper)
      .then(data => data);
  }

  getListVideosFromVimeoApi(body: any) {
    return this.httpClient.post<any>(this.GET_LIST_VIDEOS_FROM_VIDEO_API, body)
      .toPromise()
      .then(res => res as VideoCollectionWrapper)
      .then(data => data);
  }

  getFiiconceptByIdTrans(body: FiiconceptlangPK) {
    return this.httpClient.post<any>(this.GET_FII_CONCEPTS_TRANSLATED, body)
      .toPromise()
      .then(res => res as FiiConcept)
      .then(data => data);
  }

  getListValueCategoryByFieldId(body: any) {
    return this.httpClient.post<any>(this.FIND_SELECTED_CATEGORY, body)
      .toPromise()
      .then(res => res as ValueCategory[])
      .then(data => data);
  }

  getFVDetail(body: CXC2DetailWrapper) {
    return this.httpClient.post<any>(this.GET_FV_DETAIL, body)
      .toPromise()
      .then(res => res as CXC2DetailWrapper)
      .then(data => data);
  }

  createAccBalanceH(body: any) {
    return this.httpClient.post<any>(this.CREATE_ACCBALANCEH, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  updateAccBalanceH(body: any) {
    return this.httpClient.put<any>(this.UPDATE_ACCBALANCEH, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  createAccBalanceCD(body: any) {
    return this.httpClient.post<any>(this.CREATE_ACCBALANCECD, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  updateAccBalanceCD(body: any) {
    return this.httpClient.put<any>(this.UPDATE_ACCBALANCECD, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  getAccBalanceCDById(body: any) {
    return this.httpClient.post<any>(this.GET_ACCBALANCECD_BY_ID, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  getAccBalanceHById(body: any) {
    return this.httpClient.post<any>(this.GET_ACCBALANCEH_BY_ID, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  deleteFV(body: any) {
    return this.httpClient.post<any>(this.DELETE_FV, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  getLocmatctlmById(body: LocMatCtlMPK) {
    return this.httpClient.post<any>(this.GET_LOCMATCTL_M_BY_ID, body)
      .toPromise()
      .then(res => res as LocMatCtlM)
      .then(data => data);
  }

  crudLocMatCtl(body: LocMatCtlWrp) {
    return this.httpClient.post<any>(this.CRUD_LOCMATCTL, body)
      .toPromise()
      .then(res => res as LocMatCtlWrp)
      .then(data => data);
  }

  updateLocmatctlm(body: LocMatCtlM) {
    return this.httpClient.put<any>(this.UPDATE_LOCMATCTLM, body)
      .toPromise()
      .then(res => res as LocMatCtlWrp)
      .then(data => data);
  }

  createBalanceByDocument(body) {
    return this.httpClient.post<any>(this.CREATE_BALANCE_BY_DOC, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  createLocmatctlM(body: LocMatCtlM) {
    return this.httpClient.post<any>(this.CREATE_LOCMATCTLM, body)
      .toPromise()
      .then(res => res as LocMatCtlM)
      .then(data => data);
  }

  getAuthorityOptsById(body) {
    return this.httpClient.post<any>(this.GET_AUT_OPTS_BY_ID, body)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  updatePriceListItm(body: any) {
    return this.httpClient.put<any>(this.UPDATE_PRICE_LIST_ITM, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  queryForChartsWorkedByGuide(body: any) {
    return this.httpClient.post<any>(this.QUERY_FOR_CHARTS_WORKED_BY_GUIDE, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  createListFiijournaliedr(body: Fiijournaliedr[]) {
    return this.httpClient.post<any>(this.CREATE_FIIJOURNALIEDR_BY_LIST, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  listFiijournaliedrByDocId(body: any) {
    return this.httpClient.post<any>(this.LIST_FII_JOURNALIEDR_BY_DOC_ID, body)
      .toPromise()
      .then(res => res as any)
      .then(data => data);
  }

  updateFiijournaliedr(body: CXC4OfferWrapper) {
    return this.httpClient.put<any>(this.UPDATE_FII_JOURNALIEDR_ARRAY, body)
      .toPromise()
      .then(res => res as CXC4OfferWrapper)
      .then(data => data);
  }

  createDoublePartyDetail(body) {
    return this.httpClient.post<any>(this.CREATE_DOUBLE_PARTY_DETAIL, body)
      .toPromise()
      .then(res => res as ResponseVO)
      .then(data => data);
  }

  updateDoublePartyDetail(body) {
    return this.httpClient.post<any>(this.UPDATE_DOUBLE_PARTY_DETAIL, body)
      .toPromise()
      .then(res => res as ResponseVO)
      .then(data => data);
  }

  lstFVIIEconReal(body) {
    return this.httpClient.post<any>(this.LST_FVII_ECONREAL, body)
      .toPromise()
      .then(res => res as FVIIEconRealWrp[])
      .then(data => data);
  }

  validateExternGuidesAndMedia(body){
    return this.httpClient.post<any>(this.VALIDATE_EXTERN_GUIDES_AND_MEDIA, body)
      .toPromise()
      .then(res => res as GuideMediaVO[])
      .then(data => data);  
  }

  dwnFVIIEconRealXls(body) {
    return this.httpClient.post<any>(this.LST_FVII_ECONREAL_XLS, body)
      .toPromise()
      .then(res => res as ResponseFile)
      .then(data => data);
  }

}
